const texts = {
    "rus": {
        header: {
            loginBtn: "Login",
            changeLangTxt: "Change language",
            logoutBtn: "Logout"
        },
        admin: {
            delQuestion: "Вы дейсвительно хотите удалить все результаты?",
            sign: "Введите пароль:",
            passMsg: "Введите пароль:"
        },
        auth: {
            name: "Ваше имя:",
            surname: "Ваша фамилия:",
            email: "Почтовый адрес:",
            country: "Страна:",
            namePlace: "Имя",
            surnamePlace: "Фамилия",
            emailPlace: "qwerty@mail.ru",
            countryPlace: "Выбрать страну",
            loginBtn: "Войти"
        },
        main: {
            welcomeTitle: "Добро пожаловать в анкету по типам личности!",
            welcomeText: "Данная онлайн-анкета была разработана для того, чтобы вы лучше могли узнать самих себя и окружающих, лучше понимать себя, как мы себя ведём и что чувствуем, а также то, как мы влияем на других людей. Короче говоря, вы получите полностью новый взгляд на ваши сильные и слабые стороны.",
            anketaInfo: "Анкета состоит из 15 вопросов и ее заполнение займет у вас примерно 7 минут. Отвечайте честно и спонтанно.",
            inAnketBtn: "Перейти к анкете можно здесь",
            info1: "Данная анкета предоставлена вам компанией ",
            infoLink: "BPN Кыргызстан",
            infoLinkPath: "https://bpn.kg/",
            info2: ": За сильное предпринимательство в Кыргызстане!"
        },
        qInfo: {
            first: "Далее Вы увидите 15 тематически расположенных групп предложений, по четыре предложения в каждой группе.",
            second: "Выберите в каждой группе из четырех пунктов тот, который соответствует вам:",
            threeOne: "„лучше всего“ = 4 балла",
            threeTwo: "„хорошо“ = 3 балла",
            threeThree: "„не совсем“ = 2 балла",
            threeFour: "„меньше всего“ = 1 балл",
            fourty: "Это означает, что в каждой группе из четырех предложений цифры 1, 2, 3 и 4 могут встречаться только один раз.",
            fifth: "Заполняя анкету, проанализируйте свое поведение в какой-нибудь одной определенной ситуации. При этом неважно, выбираете ли Вы какую-нибудь рабочую или личную ситуацию. Но выберите для себя только в одну конкретную ситуацию!",
            inAnketBtn: "К анкете",
            inBackBtn: "Назад на старт"
        },
        question: {
            qInfo1: "Вопросы с",
            qInfo2: "по 15",
            inNextBtn: "Далее",
            inStartBtn: "Назад на старт",
            inBackBtn: "Шаг назад",
            badMessageTxT: "На странице присутсвуют неотмеченные вопросы",
            "4Punkt": "лучше всего",
            "3Punkt": "хорошо",
            "2Punkt": "не совсем",
            "1Punkt": "меньше всего",
            1: [{
                id: 1,
                title: "Я работаю стабильно.",
            },
                {
                    id: 2,
                    title: "Я работаю с воодушевлением.",
                },
                {
                    id: 3,
                    title: "Я быстро достигаю результатов.",
                },
                {
                    id: 4,
                    title: "Я работаю точно.",
                }
            ],
            2: [{
                id: 1,
                title: "Я охотно рассказываю, что со мной произошло.",
            },
                {
                    id: 2,
                    title: "Я внимательно слушаю и задаю правильные вопросы.",
                },
                {
                    id: 3,
                    title: "Я люблю слушать и даю полезные советы.",
                },
                {
                    id: 4,
                    title: "Я говорю четко и сосредоточенно",
                }
            ],
            3: [{
                id: 1,
                title: "Я с удовольствием использую новшества.",
            },
                {
                    id: 2,
                    title: "Я быстро справляюсь с трудными задачами.",
                },
                {
                    id: 3,
                    title: "Я работаю точно и проверяю правильность каждой мелочи.",
                },
                {
                    id: 4,
                    title: "Я люблю работать в команде, где всем комфортно.",
                }
            ],
            4: [{
                id: 1,
                title: "Я умею сопереживать",
            },
                {
                    id: 2,
                    title: "Я обладаю сильной волей.",
                },
                {
                    id: 3,
                    title: "Я тактичный человек.",
                },
                {
                    id: 4,
                    title: "Я полон идей.",
                }
            ],
            5: [{
                id: 1,
                title: "Я часто конкурирую с другими.",
            },
                {
                    id: 2,
                    title: "Я стараюсь создать в группе равновесие.",
                },
                {
                    id: 3,
                    title: "Я люблю компанию общительных и приятных людей.",
                },
                {
                    id: 4,
                    title: "В группе я слежу за тем, чтобы соблюдались правила.",
                }
            ],
            6: [{
                id: 1,
                title: "Перед принятием решения я охотно советуюсь с другими.",
            },
                {
                    id: 2,
                    title: "Я принимаю решения спонтанно и интуитивно.",
                },
                {
                    id: 3,
                    title: "Я быстро принимаю даже неприятные решения.",
                },
                {
                    id: 4,
                    title: "Перед принятием решения я собираю и анализирую факты.",
                }
            ],
            7: [{
                id: 1,
                title: "Я люблю начинать разговор и охотно рассказываю незнакомым людям смешные истории.",
            },
                {
                    id: 2,
                    title: "Я говорю логично и по делу.",
                },
                {
                    id: 3,
                    title: "В разговоре я стараюсь учитывать мнение других людей.",
                },
                {
                    id: 4,
                    title: "Я веду разговоры и быстро перехожу к сути.",
                }
            ],
            8: [{
                id: 1,
                title: "Я умею контролировать себя и свои чувства.",
            },
                {
                    id: 2,
                    title: "Большинство людей считают меня милым человеком.",
                },
                {
                    id: 3,
                    title: "Я чувствую состояние людей, даже если они ничего не говорят.",
                },
                {
                    id: 4,
                    title: "Я придерживаюсь своей точки зрения, даже если остальные считают иначе.",
                }
            ],
            9: [{
                id: 1,
                title: "В случае конфликтов мои аргументы объективны.",
            },
                {
                    id: 2,
                    title: "Я стараюсь избегать или сглаживать конфликты.",
                },
                {
                    id: 3,
                    title: "Я борюсь с конфликтами напрямую и без страха.",
                },
                {
                    id: 4,
                    title: "Конфликты есть всегда, поэтому я быстро о них забываю.",
                }
            ],
            10: [{
                id: 1,
                title: "Меня считают надежным человеком.",
            },
                {
                    id: 2,
                    title: "Меня считают воодушевленным человеком.",
                },
                {
                    id: 3,
                    title: "Меня считают добросовестным человеком.",
                },
                {
                    id: 4,
                    title: "Меня считают решительным человеком.",
                }
            ],
            11: [{
                id: 1,
                title: "Публичные выступления доставляют мне удовольствие.",
            },
                {
                    id: 2,
                    title: "Я предпочитаю говорить с 1-2 людьми, чтобы иметь возможность услышать и учесть их мнение.",
                },
                {
                    id: 3,
                    title: "Я говорю, чтобы убеждать фактами и знаниями.",
                },
                {
                    id: 4,
                    title: "Я произношу речь, чтобы повлиять на ситуацию и мотивировать людей действовать.",
                }
            ],
            12: [{
                id: 1,
                title: "Для меня важен результат.",
            },
                {
                    id: 2,
                    title: "Мне важна гармония.",
                },
                {
                    id: 3,
                    title: "Мне важны новшества и разнообразие.",
                },
                {
                    id: 4,
                    title: "Для меня важна точность.",
                }
            ],
            13: [{
                id: 1,
                title: "Я с легкостью могу увлечь чем-либо людей.",
            },
                {
                    id: 2,
                    title: "Мне трудно бездействовать.",
                },
                {
                    id: 3,
                    title: "Я с пониманием отношусь к желаниям и проблемам других людей.",
                },
                {
                    id: 4,
                    title: "Я сдержанный и скромный.",
                }
            ],
            14: [{
                id: 1,
                title: "Я постоянный человек.",
            },
                {
                    id: 2,
                    title: "Я осторожный человек.",
                },
                {
                    id: 3,
                    title: "Я вдохновляю других людей.",
                },
                {
                    id: 4,
                    title: "Я проявляю упорство, пока задание не будет выполнено.",
                }
            ],
            15: [{
                id: 1,
                title: "Я стремлюсь сохранять контроль.",
            },
                {
                    id: 2,
                    title: "Я стремлюсь к получению удовольствия.",
                },
                {
                    id: 3,
                    title: "Моя цель-сокращение затрат.",
                },
                {
                    id: 4,
                    title: "Мне важно действовать правильно.",
                }
            ]
        },
        result: {
            mailMsg: "Сообщение успешно доставлено!",
            goodMessageAnswer: "Сообщение доставлено на Ваш email",
            goodMessageAnswer2: "Вы можете так же предложить заполнить анкету друзьям, перейдя по ссылкам ниже!",
            title: "Оценка типов личности",
            eagleBall: "Всего баллов по типу личности «Орёл»",
            beeBall: "Всего баллов по типу личности «Пчела»",
            monkeyBall: "Всего баллов по типу личности «Обезьяна»",
            pandaBall: "Всего баллов по типу личности «Панда»",
            type: "Тип",
            balls: "Баллы",
            percents: "Проценты",
            resultTxt1: "Те характеристики, которые превышают значение 36, т.е. лежат за пределами нарисованного квадрата, с большой вероятностью, будут восприняты другими как ярко выраженные у Вас, а те, которые ниже значения 36, будут восприняты как Ваши слабые стороны. Вы можете заметить, что имеете все тенденции поведения. Итак, нет ни «Орла», ни «Пчелы» в чистом виде.",
            resultTxt12: "Чем более ярко выражены предельные значения Вашего типа личности, тем больше совпадений Вы найдёте в",
            resultTxtLink: "описании четырёх тенденций поведения",
            resultTxt2: "Если выставленные Вами баллы по четырем типам личности достаточно сбалансированы, то Вашему поведению соответствуют только некоторые, характерные для этой модели, утверждения или Вам присуще разный стиль поведения в зависимости от ситуации.",
            resultTxtBold: "Каждый человек уникален! Ваш тип личности только подчеркивает эту уникальность и не имеет ничего общего с оценкой «Хорошо» или «Плохо». Это отражение Вашей личности, того, как Вас воспринимают другие.",
            resultTxt3: "Если Вы хотите узнать больше о различных тенденциях поведения четырёх типов личности, то запишитесь к нам на",
            resultTxt4: "семинар по управлению персоналом",
            resultBpnLink: "https://bpn.kg/business-academy/summary",
            backOnBtnLink: "https://bpn.kg/",
            sendMailBtn: "Отправить оценку в формате pdf",
            shareWithFriendsBtn: "Поделиться анкетой с друзьями!",
            restartBtn: "Еще раз заполнить анкету",
            backOnMainBtn: "Назад на страницу BPN",
            emailHead: "Рассылка",
            emailMessage: "Введите почту",
            emailSendBtn: "Отправить",
            emailLinkTxt: "Ссылка на анкету по типам личности",
            emailSuccessTxt: "Было отправлено!",
            emailPlaceholder: "На эту почту будет отправлено сообщение",
            emailMessageToFriend: "Тип личности от Business Professionals Network (BPN).\nДобрый день! Вы обязательно должны заполнить эту анкету по типам личности! Вы можете найти её здесь:"
        },
        fourTendentions: {
            title: "Описание четырёх тенденций поведения",
            eagleTitle: "«Орёл»",
            eagleGrayTxt: "«Орлу» требуется признание за все дела и достижения. Трудные задачи и победы мотивируют его.",
            eagleTxt: "«Орел» очень уверен в себе и нацелен на достижение результата, который он намерен\n" +
                "получить как можно скорее. Он стремится быть деятельным до тех пор, пока\n" +
                "необходимый результат не достигнут. Трудные задачи подстегивают его работать еще\n" +
                "больше. Он смело берется за проблемы и ощущает огромное удовлетворение, если\n" +
                "смог преодолеть сопротивление или конкурентов. Он подвергает сомнению даже\n" +
                "устоявшиеся вещи и способен мыслить нестандартно. «Орел» быстро переходит к сути\n" +
                "дела, обладает пробивным, прямым, открытым (и иногда даже грубым) характером.\n" +
                "Ему нравится, когда окружающие общаются сфокусировано и быстро переходят к сути.\n" +
                "«Орел» любит разнообразную и новую деятельность и стремится быть своим\n" +
                "собственным шефом. Он знает, чего хочет, берет контроль на себя, сам определяет\n" +
                "свое окружение и диктует другим, что они должны делать. Он требует многого от себя,\n" +
                "в том числе и от других и может перегнуть палку, так как не осознает, что окружающие\n" +
                "его люди не обладают таким же количеством энергии, что и он.",
            eagleSlogan1: "Девиз «Орла»:",
            eagleSlogan2: "«Выполнено! Цель достигнута! Все под контролем!»",
            monkeyTitle: "«Обезьяна»",
            monkeyGrayTxt: "«Обезьяна» стремится к тому, чтобы то, как она себя ведет, нравилось людям. Ее\n" +
                "мотивирует получение удовольствия, и она любит заводить знакомства.",
            monkeyTxt: "«Обезьяна» не может не мотивировать, не убеждать и не влиять на других людей. Для\n" +
                "этого она стремится максимально высказаться и быть услышанной. Ведет беседу\n" +
                "интересно и открыто, выражает свои чувства. При этом ищет подтверждения и\n" +
                "одобрения со стороны собеседника. Больше всего предпочитает работать вместе с\n" +
                "другими. Говоря, она продолжает думать, поэтому может отвергать свои собственные,\n" +
                "только что высказанные идеи. Легко вдохновляет и привлекает на свою сторону\n" +
                "окружающих. Перепрыгивает с одной темы на другую, редко задерживается на одной\n" +
                "теме. Ее действия и решения часто спонтанны и интуитивны. Детали, точность и\n" +
                "контроль парализуют ее фантазию. Зачастую тратит энергию впустую, так как делает\n" +
                "слишком много дел одновременно, не имея четкой цели перед глазами.",
            monkeySlogan1: "Девиз «Обезьяны»:",
            monkeySlogan2: "«Давайте получать удовольствие! Это было весело!»",
            pandaTitle: "«Панда»",
            pandaGrayTxt: "«Панда» предпочитает стабильное, предсказуемое и упорядоченное окружение и любит дружелюбную и непринужденную обстановку.",
            pandaTxt: "В абсолютном приоритете у «Панды» гармония и хороший командный дух. Она\n" +
                "стремится поддерживать окружающих и следит за тем, чтобы отношения в коллективе\n" +
                "были хорошими. Ясные и справедливые договоренности, а также предсказуемые\n" +
                "процессы дают ей необходимое чувство безопасности. Она может наслаждаться\n" +
                "приятным обществом и предпочитает выполнять свою работу в спокойной обстановке,\n" +
                "но в состоянии подстроиться под темп работы других людей, чтобы соблюсти\n" +
                "требования. Если поручить задание «Панде», можно быть уверенным в его\n" +
                "выполнении. Она прекрасно умеет планировать и шаг за шагом выполнять работу.\n" +
                "«Панда» не любит находиться в центре внимания и избегает ситуаций, когда\n" +
                "необходимо представить себя с особо выгодной стороны. Любит работать в команде,\n" +
                "пока в ней царит хорошая атмосфера. В «Панде просыпаются скрытые силы, если она\n" +
                "видит, что кто-то нуждается в ее помощи.",
            pandaSlogan1: "Девиз «Панды»:",
            pandaSlogan2: "«У всех все хорошо! Мы прекрасно проводим время вместе!»",
            beeTitle: "«Пчела»",
            beeGrayTxt: "«Пчела» стремится к тому, чтобы ее выдающиеся заслуги получили признание. Ее\n" +
                "мотивируют цифры, факты и точность.",
            beeTxt: "«Пчелу» подстегивают стандарты и требования к качеству. При этом она охотно\n" +
                "анализирует необходимые вещи, взвешивает все «за» и «против» и общается\n" +
                "дипломатично и скорее сдержанно. Она стремится к тому, чтобы «правильно» сделать\n" +
                "правильные вещи, избегает ссор и критики и придает большое значение точности.\n" +
                "Составляет подробные планы и учитывает все детали, иногда чрезмерно увлекается\n" +
                "перфекционизмом вместо того, чтобы выполнить другие, не менее важные дела.\n" +
                "Чувствует себя комфортно, когда ожидания четко определены, а лучше всего\n" +
                "письменно зафиксированы в описании процессов. В эмоциональных ситуациях\n" +
                "чувствует себя некомфортно и предпочитает объективные и логические доводы.\n" +
                "Строго разделяет личную жизнь и работу. Из-за того, что ведет себя холодно и\n" +
                "\n" +
                "11\n" +
                "сдержано, почти не показывая эмоций, воспринимается окружающими как нечуткий и\n" +
                "бессердечный человек. Однако на деле все совершенно иначе: даже если «Пчела»\n" +
                "внешне такой не кажется, она часто чуткая и очень ранимая. Она любит работать с\n" +
                "другими людьми, которые работают организованно и придерживаются высоких\n" +
                "стандартов. «Пчела» не слишком жаждет действий, в большинстве случаев требует\n" +
                "толчка со стороны, но когда просыпается аппетит к работе, дисциплинированно корпит\n" +
                "над проблемой, пока полностью ее не решит.",
            beeSlogan1: "Девиз «Пчелы»:",
            beeSlogan2: "«Все должно быть сделано правильно. Все должно быть верно. Отличная работа!»",
        }
    },
    "en": {
        header: {
            loginBtn: "Login",
            changeLangTxt: "Change language",
            logoutBtn: "Logout"
        },
        admin: {
            delQuestion: "Do you want delete all results?",
            sign: "Password:",
            passMsg: "Password:"
        },
        auth: {
            name: "Name:",
            surname: "Surname:",
            email: "Address:",
            country: "Country:",
            namePlace: "Name",
            surnamePlace: "Surname",
            emailPlace: "qwerty@mail.ru",
            countryPlace: "Select country",
            loginBtn: "Login"
        },
        main: {
            welcomeTitle: "A warm welcome to the personality profile questionnaire!",
            welcomeText: "This online questionnaire was developed to help you get to know yourself and others better,\n" +
                "to understand who we are, how we act, feel and impact others. In short, you will get a\n" +
                "completely new view of your own strengths and weaknesses.",
            anketaInfo: "The questionnaire has 15 questions and it takes about 7 minutes to fill in. Answer honestly\n" +
                "and spontaneously.",
            inAnketBtn: "Click here for the questionnaire",
            info1: "This questionnaire is brought to you by",
            infoLink: " BPN Rwanda:",
            infoLinkPath: "https://bpn.rw/en/bpn-rwanda/bpn-rwanda",
            info2: " For strong entrepreneurship in\n" +
                "Rwanda!"
        },
        qInfo: {
            first: "In the following, you will be presented 15 thematically arranged groups of sentences, each\n" +
                "with four sentences.",
            second: "In each group of sentences, decide on the sentence that suits you:",
            threeOne: "„most closely“ corresponds = 4 scores",
            threeTwo: "„second most closely“ corresponds = 3 scores",
            threeThree: "„rather not“ corresponds = 2 scores",
            threeFour: "„least“ = 1 score",
            fourty: "This means that in each group of four, the numbers 1, 2, 3, and 4 must occur exactly once.",
            fifth: "When filling in the questionnaire, think of a specific environment. It does not matter whether\n" +
                "you fill it in for a professional or private situation. But decide on a specific environment!",
            inAnketBtn: "To the questionnaire",
            inBackBtn: "Back to the start"
        },
        question: {
            qInfo1: "Question",
            qInfo2: "of 15",
            inNextBtn: "Next",
            inStartBtn: "Back to the start",
            inBackBtn: "Step back",
            badMessageTxT: "There are unmarked questions on the page",
            "4Punkt": "most closely",
            "3Punkt": "second most closely",
            "2Punkt": "rather not",
            "1Punkt": "least",
            1: [{
                id: 1,
                title: "I work consistently",
            },
                {
                    id: 2,
                    title: "I work with enthusiasm",
                },
                {
                    id: 3,
                    title: "I achieve results quickly",
                },
                {
                    id: 4,
                    title: "I work accurately",
                }
            ],
            2: [{
                id: 1,
                title: "I like to tell what happened to me",
            },
                {
                    id: 2,
                    title: "I listen carefully and ask the right questions",
                },
                {
                    id: 3,
                    title: "I like to listen and give advice that helps",
                },
                {
                    id: 4,
                    title: "I speak clearly and with focus",
                }
            ],
            3: [{
                id: 1,
                title: "I like to tackle new things",
            },
                {
                    id: 2,
                    title: "I finish challenging tasks quickly",
                },
                {
                    id: 3,
                    title: "I work accurately and make sure that details are correct",
                },
                {
                    id: 4,
                    title: "I like to work in a team where everyone is doing well",
                }
            ],
            4: [{
                id: 1,
                title: "I am compassionate",
            },
                {
                    id: 2,
                    title: "I am strong-willed",
                },
                {
                    id: 3,
                    title: "I am tactful",
                },
                {
                    id: 4,
                    title: "I am imaginative",
                }
            ],
            5: [{
                id: 1,
                title: "I am often competitive with others",
            },
                {
                    id: 2,
                    title: "I try to balance out in a group",
                },
                {
                    id: 3,
                    title: "I like to have sociable and happy rounds",
                },
                {
                    id: 4,
                    title: "In a group, I try to make sure that the rules are followed",
                }
            ],
            6: [{
                id: 1,
                title: "I also ask others before I decide",
            },
                {
                    id: 2,
                    title: "I decide spontaneously and intuitively",
                },
                {
                    id: 3,
                    title: "I also make unpleasant decisions quickly",
                },
                {
                    id: 4,
                    title: "I collect and analyse facts before I decide",
                }
            ],
            7: [{
                id: 1,
                title: "I like to initiate conversations and tell funny stories even to strangers"
            },
                {
                    id: 2,
                    title: "I speak objectively and logically",
                },
                {
                    id: 3,
                    title: "I try to respond to others in conversation",
                },
                {
                    id: 4,
                    title: "I lead discussions and get to the point quickly",
                }
            ],
            8: [{
                id: 1,
                title: "I can control myself and my feelings well",
            },
                {
                    id: 2,
                    title: "Basically, most people find me friendly",
                },
                {
                    id: 3,
                    title: "I notice how others are feeling, even if they don't say\n" +
                        "anything",
                },
                {
                    id: 4,
                    title: "I stay loyal to my line, even if everyone sees it differently",
                }
            ],
            9: [{
                id: 1,
                title: "I argue objectively in conflicts",
            },
                {
                    id: 2,
                    title: "I try to avoid or mediate conflicts",
                },
                {
                    id: 3,
                    title: "I deal with conflicts directly and without fear",
                },
                {
                    id: 4,
                    title: "Conflicts just happen, so I forget them quickly",
                }
            ],
            10: [{
                id: 1,
                title: "People see me as reliable",
            },
                {
                    id: 2,
                    title: "People experience me as enthusiastic",
                },
                {
                    id: 3,
                    title: "People experience me as conscientious",
                },
                {
                    id: 4,
                    title: "People experience me as determined",
                }
            ],
            11: [{
                id: 1,
                title: "I enjoy speaking in front of many people",
            },
                {
                    id: 2,
                    title: "I prefer to speak to only 1 or 2 people so that I can be\n" +
                        "responsive to them",
                },
                {
                    id: 3,
                    title: "I speak to convince with facts and knowledge",
                },
                {
                    id: 4,
                    title: "I speak to make a difference and get people to do things",
                }
            ],
            12: [{
                id: 1,
                title: "Results are important to me",
            },
                {
                    id: 2,
                    title: "Harmony is important to me",
                },
                {
                    id: 3,
                    title: "Novelty and variety are important to me",
                },
                {
                    id: 4,
                    title: "Accuracy is important to me",
                }
            ],
            13: [{
                id: 1,
                title: "I can easily win people over to something",
            },
                {
                    id: 2,
                    title: "It is difficult for me to be idle",
                },
                {
                    id: 3,
                    title: "I have understanding for the concerns and problems of\n" +
                        "others",
                },
                {
                    id: 4,
                    title: "I tend to be reserved and aloof",
                }
            ],
            14: [{
                id: 1,
                title: "I am a steady person",
            },
                {
                    id: 2,
                    title: "I am cautious",
                },
                {
                    id: 3,
                    title: "I am inspiring",
                },
                {
                    id: 4,
                    title: "I am persistent until something is done",
                }
            ],
            15: [{
                id: 1,
                title: "I want to be in control",
            },
                {
                    id: 2,
                    title: "I want to have fun",
                },
                {
                    id: 3,
                    title: "I want to have little effort",
                },
                {
                    id: 4,
                    title: "I want it to be right",
                }
            ]
        },
        result: {
            mailMsg: "The message has been delivered to your email address.",
            goodMessageAnswer: "The message has been delivered to your email address.",
            goodMessageAnswer2: "You can also share this questionnaire with friends using the link below:",
            title: "Evaluation of personality profile",
            eagleBall: "Total score Personality type «Eagle»",
            beeBall: "Total score Personality type «Bee»",
            monkeyBall: "Total score Personality type «Monkey»",
            pandaBall: "Total score Personality type «Panda»",
            type: "Type",
            balls: "Scores",
            percents: "Percentage",
            resultTxt1: "Those characteristics which exceed the value of 36, i.e. lie outside the drawn square, are\n" +
                "more likely to be perceived as existing, those which lie below the value of 36 are more likely\n" +
                "to be perceived as a deficiency. You will notice that you possess parts of all behavioural\n" +
                "tendencies. So, there is neither the «eagle» nor the «bee» in pure form.",
            resultTxt12: "The more differentiated the scores of your personality profile are, the more you will see\n" +
                "yourself in",
            resultTxtLink: "the characteristics of the four behavioural tendencies.",
            resultTxt2: "If your scores on the four\n" +
                "personality types are somewhat balanced, you will only agree with part of the statements or\n" +
                "show different behavioural tendencies depending on the situation.",
            resultTxtBold: "Every person is unique! Your personality profile shows this uniqueness and has nothing to do\n" +
                "with good or bad. It gives like a mirror image of your personality, how others perceive you.",
            resultTxt3: "If you would like to know more about the behavioural tendencies of the four personality types,\n" +
                "then please register today for the",
            resultTxt4: "BPN Leadership Seminar",
            resultBpnLink: "https://bpn.rw/en/business-academy/overview",
            backOnBtnLink: "https://bpn.rw/en/bpn-rwanda/bpn-rwanda",
            sendMailBtn: "Send evaluation as a pdf\n" +
                "\n" +
                "file",
            shareWithFriendsBtn: "Share the questionnaire with friends",
            restartBtn: "Fill in the questionnaire again",
            backOnMainBtn: "Back to the BPN starting page",
            emailHead: "Newsletter",
            emailMessage: "Email",
            emailSendBtn: "Send",
            emailLinkTxt: "Link to Personality Questionnaire",
            emailSuccessTxt: "Was send!",
            emailPlaceholder: "A message will be sent to this email",
            emailMessageToFriend: "Personality Type from Business Professionals Network (BPN).\n" +
                "Good afternoon You should definitely fill out this personality type questionnaire! You can find it here:"
        },
        fourTendentions: {
            title: "Descriptions of the four behavioural tendencies",
            eagleTitle: "«The eagle»",
            eagleGrayTxt: "«The eagle» wants recognition for what he does and achieves. He is motivated by\n" +
                "challenges and victories.",
            eagleTxt: "The Eagle has great self-confidence and is focused on results that he wants to achieve as\n" +
                "quickly as possible. He has the urge to be active until he has achieved the desired results.\n" +
                "Challenges incite him to do even better. He courageously tackles problems and experiences\n" +
                "great satisfaction when he can overcome resistance or even competition. He also questions\n" +
                "the status quo and can think outside the box. The Eagle gets to the heart of the matter\n" +
                "quickly, is assertive, direct, open (and sometimes rough). He loves it when others\n" +
                "communicate in a focused way and get to the point quickly. The Eagle likes varied and new\n" +
                "activities and wants to be his own leader. He knows what he wants, naturally takes control,\n" +
                "likes to determine his environment and tells others what to do. He demands a lot from\n" +
                "himself, but also from others, and can therefore sometimes be overtaxed because he is not\n" +
                "aware that not everyone has the same amount of energy as he does.",
            eagleSlogan1: "His motto:",
            eagleSlogan2: "«Done! Goal achieved! Everything under control!»",
            monkeyTitle: "«The monkey»",
            monkeyGrayTxt: "Wants people to like the way he acts and behaves. Is motivated with fun and likes to socialise.",
            monkeyTxt: "The monkey cannot help but want to motivate, convince and influence others. To do this, he\n" +
                "wants to express himself extensively and be heard. He communicates excitingly, openly and\n" +
                "expresses his feelings. In doing so, he always seeks confirmation and acceptance from his\n" +
                "counterpart. He prefers to work with others. He thinks while he speaks, so he can discard his\n" +
                "own ideas while still speaking. He can easily inspire and win others with his stories. He is\n" +
                "volatile and rarely stays on one topic for long. His actions and decisions are often\n" +
                "spontaneous and intuitive. Details, accuracy and control paralyse his creativity. His energy is\n" +
                "often wasted because he gets bogged down in too many activities or has no clearly defined\n" +
                "goal in mind.",
            monkeySlogan1: "His motto:",
            monkeySlogan2: "«Let's have fun! That was fun!»",
            pandaTitle: "«The panda»",
            pandaGrayTxt: "The Panda prefers a stable, predictable and orderly environment and loves a relaxed and\n" +
                "friendly atmosphere.",
            pandaTxt: "Harmony and a good team spirit are absolute priorities for him. He wants to support others\n" +
                "and ensure good relationships. Clear and fair agreements as well as predictable procedures\n" +
                "give him the security he needs. He can enjoy being at ease with others and prefers to work\n" +
                "through his work at his leisure, but adjusts his pace to meet deadlines. You can rely on the\n" +
                "completion of tasks when you give them to a Panda. He excels as a good planner and works\n" +
                "through his tasks step by step. The Panda does not like to be in the limelight and therefore\n" +
                "avoids making himself look too good. He likes to work with people as long as there is a good\n" +
                "working atmosphere. When other people need his help, the otherwise rather sluggish Panda\n" +
                "draws on hidden strengths.",
            pandaSlogan1: "His motto:",
            pandaSlogan2: "«Everyone is doing well! We have a good time together!»",
            beeTitle: "«The bee»",
            beeGrayTxt: "Wants her excellent work to be recognised. Is motivated by facts, figures and accuracy.",
            beeTxt: "The bee is driven by standards and quality demands. To this end, she likes to analyse the\n" +
                "necessary things, weigh the pros and cons and communicate diplomatically and rather\n" +
                "reservedly. She absolutely wants to do the right thing «right» avoid annoyance and criticism\n" +
                "and pays attention to precision and accuracy. She plans precisely and takes all details into\n" +
                "account, but then sometimes loses herself in perfection instead of also pushing other\n" +
                "important things. She feels comfortable when expectations are clearly defined and preferably\n" +
                "written down in a process description. She is not particularly comfortable in emotionally\n" +
                "charged situations and prefers factual and logical arguments. Private life and work are\n" +
                "strictly separated. Because she often appears cool and reserved and hardly shows any\n" +
                "feelings, she is often judged as insensitive and cold-hearted, although the opposite is often\n" +
                "the case: even if one cannot perceive it outwardly, they are often sensitive and easily hurt.\n" +
                "Bees like to work with other people who are organised and also have high standards. They\n" +
                "don&#39;t have so much drive, but mostly need stimulation from outside, but once their appetite\n" +
                "for a problem is awakened, they can stick to something with a lot of discipline until it is\n" +
                "completely solved.",
            beeSlogan1: "His motto:",
            beeSlogan2: "«It has to be done right. It has to be right. Excellent work!»",
        }
    },
    "keni": {
        header: {
            loginBtn: "Login",
            changeLangTxt: "Change language",
            logoutBtn: "Logout"
        },
        admin: {
            delQuestion: "Urashaka rwose gusiba ibisubizo byose?",
            sign: "Password:",
            passMsg: "Password:"
        },
        auth: {
            name: "Name:",
            surname: "Surname:",
            email: "Address:",
            country: "Country:",
            namePlace: "Name",
            surnamePlace: "Surname",
            emailPlace: "qwerty@mail.ru",
            countryPlace: "Select country",
            loginBtn: "Login"
        },
        main: {
            welcomeTitle: "Murakaza neza ku ifishi y’umwirondoro wa kamere!",
            welcomeText: "Iyi fishi y’ibibazo yo kuri murandasi yateguwe kugira ngo igufashe kumenya neza\n" +
                "wowe ubwawe ndetse n’abandi, gusobanukirwa abo turibo, uko dukora, twumva\n" +
                "abandi tukanagira ingaruka ku bandi. Muri make, uzagira imibonere mishya ku\n" +
                "mbaraga n’intege nke byawe.",
            anketaInfo: "Iyi fishi y’ibibazo igizwe n’ibibazo 15 kandi bifata iminota 7 kuyuzuza. Subiza mu\n" +
                "bunyangamugayo kandi ubikorane ubushake.",
            inAnketBtn: "Kanda hano ugere ku ifishi y’ibibazo",
            info1: "Iyi fishi y’ibibazo wayiteguriwe na ",
            infoLink: "BPN Rwanda",
            infoLinkPath: "https://bpn.rw/rw/bpn-rwanda/bpn-rwanda",
            info2: ": Kubwo kwihangira imirimo ihamye\n" +
                "mu Rwanda!"
        },
        qInfo: {
            first: "Ku mpapuro zikurikira hariho amatsinda 15 buri ryose rigiye rigira interuro enye.",
            second: "Muri buri tsinda, hitamo interuro ubona ihuye na:",
            threeOne: "„Nibyo cyane“ ingana na = amanota 4",
            threeTwo: "„Nibyo buke“ ingana na = amanota 3",
            threeThree: "„Urebye sibyo“ ingana na = amanota 2",
            threeFour: "„Sibyo“ ingana na = inota 1",
            fourty: "Ibi bivuze ko muri buri tsinda rya bine, imibare 1, 2, 3 na 4 ishobora kugaragaramo\n" +
                "rimwe gusa.",
            fifth: "Mu gihe cyo kuzuza iyi fishi y’ ibibazo, uzirikane ibihe ujya ubamo runaka mu\n" +
                "bitekerezo. Ntacyo bitwaye niba wujuje iyi fishi ku bibazo byo mu kazi cyangwa mu\n" +
                "buzima busanzwe. Ariko hitamo kimwe gusa muri ibyo ibihe.",
            inAnketBtn: "Jya ku ifishi y’ ibibazo",
            inBackBtn: "Garuka ahatangira"
        },
        question: {
            qInfo1: "Ikibazo",
            qInfo2: "kuri 15",
            inNextBtn: "Jya ahakurikira",
            inStartBtn: "Jya ahatangira",
            inBackBtn: "Garuka inyuma",
            badMessageTxT: "На странице присутсвуют неотмеченные вопросы",
            "4Punkt": "Nibyo cyane",
            "3Punkt": "Nibyo buke",
            "2Punkt": "Urebye sibyo",
            "1Punkt": "Sybio",
            1: [{
                id: 1,
                title: "Nkora ntatezuka",
            },
                {
                    id: 2,
                    title: "Nkorana ishyaka",
                },
                {
                    id: 3,
                    title: "Ngera ku bisubizo vuba",
                },
                {
                    id: 4,
                    title: "Nkora noza",
                }
            ],
            2: [{
                id: 1,
                title: "Nkunda kuvuga ibyambayeho",
            },
                {
                    id: 2,
                    title: "Ntega amatwi nitonze nkabaza ibibazo bikwiye",
                },
                {
                    id: 3,
                    title: "Nkunda gutega amatwi no gutanga inama zubaka",
                },
                {
                    id: 4,
                    title: "Mvuga ntomoye kandi nganisha ku ntego",
                }
            ],
            3: [{
                id: 1,
                title: "Nkunda gukora ku bintu bishya",
            },
                {
                    id: 2,
                    title: "Ndangiza vuba imirimo itoroshye",
                },
                {
                    id: 3,
                    title: "Nkora noza kandi ndeba neza ko amakuru\n" +
                        "acukumbuye",
                },
                {
                    id: 4,
                    title: "Nkunda gukorera mw’itsinda aho buri wese aguwe\n" +
                        "neza",
                }
            ],
            4: [{
                id: 1,
                title: "Ngira impuhwe",
            },
                {
                    id: 2,
                    title: "Ngira ubushake bukomeye",
                },
                {
                    id: 3,
                    title: "Ngira amakenga",
                },
                {
                    id: 4,
                    title: "Ngira ibitekerezo bishya byinshi",
                }
            ],
            5: [{
                id: 1,
                title: "Akenshi nkunze guhatana n’abandi",
            },
                {
                    id: 2,
                    title: "Ngerageza kuba umuhuza mu matsinda",
                },
                {
                    id: 3,
                    title: "Nkunda ahari abantu basabana kandi bishimye",
                },
                {
                    id: 4,
                    title: "Mw’itsinda, ngerageza kureba neza ko amabwirizwa\n" +
                        "akurikizwa",
                }
            ],
            6: [{
                id: 1,
                title: "Mbaza n’abandi mbere yuko mfata umwanzuro",
            },
                {
                    id: 2,
                    title: "Mfata ibyemezo kubwanjye kandi ntabitinzeho",
                },
                {
                    id: 3,
                    title: "Njya mfata n’ibyemezo bitagwa neza",
                },
                {
                    id: 4,
                    title: "Nkusanya kandi nkasesengura ibimenyetso mbere\n" +
                        "yo gufata ibyemezo",
                }
            ],
            7: [{
                id: 1,
                title: "Nkunda gutangiza ibiganiro no kuvuga inkuru\n" +
                    "zisekeje, ndetse n’abantu tutaziranye",
            },
                {
                    id: 2,
                    title: "Mvuga nta marangamutima kandi ibintu byumvikana",
                },
                {
                    id: 3,
                    title: "Mu biganiro ngerageza kumva abandi",
                },
                {
                    id: 4,
                    title: "Nkora ibiganiro kandi nkagera ku ngingo byihuse",
                }
            ],
            8: [{
                id: 1,
                title: "Nshobora kwifata neza no ku byiyumvo byanjye",
            },
                {
                    id: 2,
                    title: "Mubisanzwe, abantu benshi basanga ngira urugwiro",
                },
                {
                    id: 3,
                    title: "Mbona icyo uko abandi bantu biyumva, nubwo\n" +
                        "ntacyo bavuga",
                },
                {
                    id: 4,
                    title: "Nkomeza kuguma mu murongo wanjye, nubwo\n" +
                        "abantu bose baba babibona ukundi",
                }
            ],
            9: [{
                id: 1,
                title: "Mu makimbirane, ntanga ibitekerezo bifatika",
            },
                {
                    id: 2,
                    title: "Ngerageza kwirinda amakimbirane cyangwa\n" +
                        "nkayakemura",
                },
                {
                    id: 3,
                    title: "Mpangara amakimbirane mu buryo butaziguye kandi\n" +
                        "nta bwoba",
                },
                {
                    id: 4,
                    title: "Amakimbirane ni ikintu kibaho rwose, niyo mpamvu\n" +
                        "nyibagirwa vuba",
                }
            ],
            10: [{
                id: 1,
                title: "Abantu bambona nkuwo kwizerwa",
            },
                {
                    id: 2,
                    title: "Abantu bambona nkuwishima",
                },
                {
                    id: 3,
                    title: "Abantu bambona nkushishoza",
                },
                {
                    id: 4,
                    title: "Abantu bambona nkuwiyemeza",
                }
            ],
            11: [{
                id: 1,
                title: "Nshimishwa no kuvuga imbere y’abantu benshi",
            },
                {
                    id: 2,
                    title: "Nkunda kuvugana n’umuntu 1 cyangwa 2 kugira ngo\n" +
                        "mbashe kubasubiza neza",
                },
                {
                    id: 3,
                    title: "Mvuga nifashishije ibimenyetso n’ubumenyi kugira\n" +
                        "ngo nemeze",
                },
                {
                    id: 4,
                    title: "Mvuga kugira ngo ngere ku kintu kandi ntume\n" +
                        "abantu bakora ibintu",
                }
            ],
            12: [{
                id: 1,
                title: "Umusaruro ni ngombwa kuri njye",
            },
                {
                    id: 2,
                    title: "Guhuza n’abandi ni ngombwa kuri njye",
                },
                {
                    id: 3,
                    title: "Ibintu bishya n’ibintu bitandukanye ni ngombwa kuri\n" +
                        "njye",
                },
                {
                    id: 4,
                    title: "Impamo ni ngombwa kuri njye",
                }
            ],
            13: [{
                id: 1,
                title: "Nshobora kwemeza abantu byoroshye ku bintu\n" +
                    "runaka",
            },
                {
                    id: 2,
                    title: "Biramvuna kwicara ntacyo nkora",
                },
                {
                    id: 3,
                    title: "Numva ibyifufzo n’ibibazo by’abandi",
                },
                {
                    id: 4,
                    title: "Sinisukira ibintu kandi sinshamadutse",
                }
            ],
            14: [{
                id: 1,
                title: "Ndi umuntu uhamye",
            },
                {
                    id: 2,
                    title: "Ndi umuntu wigengesera",
                },
                {
                    id: 3,
                    title: "Ndi umuntu bareberaho",
                },
                {
                    id: 4,
                    title: "Ndi umuntu udatezuka kugeza ikintu gikozwe",
                }
            ],
            15: [{
                id: 1,
                title: "Nshaka kugumana ubuyobozi",
            },
                {
                    id: 2,
                    title: "Nkunda kwinezeza",
                },
                {
                    id: 3,
                    title: "Nshaka gukoresha imbaraga nke",
                },
                {
                    id: 4,
                    title: "Nshaka ko ibintu biba ari byo",
                }
            ]
        },
        result: {
            mailMsg: "Сообщение успешно доставлено!",
            goodMessageAnswer: "Сообщение доставлено на Ваш email",
            goodMessageAnswer2: "Вы можете так же предложить заполнить анкету друзьям, перейдя по ссылкам ниже!",
            title: "Isesengura ry’umwirondoro wa kamere",
            eagleBall: "Igiteranyo cy’amanota y’ubwoko\n" +
                "bwa kamere ya «Kagoma»",
            beeBall: "Igiteranyo cy’amanota y’ubwoko\n" +
                "bwa kamere y’ «Uruyuki»",
            monkeyBall: "Igiteranyo cy’amanota y’ubwoko\n" +
                "bwa kamere ya «Inkende»",
            pandaBall: "Igiteranyo cy’amanota y’ubwoko\n" +
                "bwa kamere y’ «Panda»",
            type: "Ubwoko",
            balls: "Amanota",
            percents: "Ijanisha",
            resultTxt1: "Ibyo bimenyetso biranga birenze agaciro ka 36, ni ukuvuga kuba hanze ya\n" +
                "mpandenye yashushanyijwe, birashoboka cyane ko byafatwa nk’ibihari, ibyo biri\n" +
                "munsi yagaciro ka 36 birashoboka cyane ko byafatwa nk’ibibura. Uzabona ko ufite\n" +
                "ibice byose by’imyitwarire ya muntu. Bityo rero nta «kagoma» cyangwa «uruyuki»\n" +
                "bibaho mu buryo butavangiye.",
            resultTxt12: "Uko amanota y’umwirondoro wa kamere agenda atandukana, niko uzarushaho\n" +
                "kwibona mu",
            resultTxtLink: "bimenyetso biranga ubwoko bune bw’imyitwarire.",
            resultTxt2: "Niba amanota yawe\n" +
                "y’ubwoko bune aringaniye, uzemera gusa igice cy’amagambo cyangwa ugaragaze\n" +
                "imyitwarire itandukanye bitewe n’uko ibintu bimeze.",
            resultTxtBold: "Umuntu wese arihariye! Umwirondoro wawe wa kamere werekana ubudasa kandi\n" +
                "ntaho uhuriye na byiza cyangwa bibi. Utanga nk’ishusho mu ndorerwamo ya kamere\n" +
                "yawe, y’uko abandi bakubona.",
            resultTxt3: "Niba wifuza kumenya byinshi ku byerekeranye n’imyitwarire y’ubwoko bune bwa\n" +
                "kamere, nyamuneka iyandikishe uyu munsi mu",
            resultTxt4: "Mahugurwa y’Imiyobrere y’Abakozi ya BPN.",
            resultBpnLink: "https://bpn.rw/business-academy/ishusho-rusange",
            backOnBtnLink: "https://bpn.rw/rw/bpn-rwanda/bpn-rwanda",
            sendMailBtn: "Ohereza isesengura nka dosiye\n" +
                "\n" +
                "iri muri pdf",
            shareWithFriendsBtn: "Sangiza ifishi y’ibibazo inshuti zawe",
            restartBtn: "Ongera wuzuze ifishi y’ibibazo",
            backOnMainBtn: "Garuka ku rupapuro rwa BPN rw’\n" +
                "\n" +
                "ahatangira",
            emailHead: "Newsletter",
            emailMessage: "Email",
            emailSendBtn: "Send",
            emailLinkTxt: "Link to Personality Questionnaire",
            emailSuccessTxt: "Was send!",
            emailPlaceholder: "A message will be sent to this email",
            emailMessageToFriend: "Niba wifuza gusobanukirwa byinshi kubyerekeranye n’imyitwarire y’ubwoko bune\n" +
                "bwa kamere, noneho iyandikishe uyu munsi mu Mahugurwa y’Imiyoborere y’Abakozi\n" +
                "ya BPN."
        },
        fourTendentions: {
            title: "Ibisobanuro by’imyitwarire ine",
            eagleTitle: "«Kagoma»",
            eagleGrayTxt: "Kagoma ikenera gushimwa ku byo ikora kandi ikabigeraho. Ashishikarizwa no\n" +
                "guhura n’inzitizi no gutsinda.",
            eagleTxt: "Kagoma afite kwigirira icyizere kinini kandi yibanda ku bisubizo ashaka kugeraho ku\n" +
                "buryo bwihuse bushoboka. Afite ubushake bwo gukora kugeza ageze ku bisubizo\n" +
                "bigamijwe. Inzitizi zimutera imbaraga zo kurushaho gukora. Akemurana ibibazo\n" +
                "ubutwari kandi akanyurwa cyane mu gihe ageze ku ntsinzi mu guhangana\n" +
                "n’ibimuzitira cyangwa kurushanwa n’abakeba. Kuri ibyo aba yibaza ku bintu biriho\n" +
                "kandi ashobora gutekereza ku bintu byinshi binyuranye.\n" +
                "Kagoma agera kw’ipfundo ry’ikibazo vuba, aremeza, ntazigura, arafungutse (kandi\n" +
                "rimwe na rimwe arakara). Akunda ko abamuvugisha badatinda mu magambo\n" +
                "ahubwo bagusha ku ngingo. Kagoma akunda akazi kataguma ari ka kandi ndetse\n" +
                "n’akazi gashya kandi akunda kwiyobora. Azi icyo ashaka, birumvikana ko afata\n" +
                "ibyemezo, aha icyerekezo abamukikije no kubwira abandi icyo gukora. Asaba byinshi\n" +
                "kuri we ubwe, ariko no ku bandi, bityo rero rimwe na rimwe ashobora gusaba ibirenze\n" +
                "kuko atazi ko abantu bose badafite imbaraga zingana n’ ize.",
            eagleSlogan1: "Intego ye:",
            eagleSlogan2: "«Byakozwe! Intego yagezweho! Ibintu byose mbifite mu maboko!»",
            monkeyTitle: "«Inkende»",
            monkeyGrayTxt: "Yifuza ko abantu bakunda uburyo yitwara. Ashishikajwe no kwinezeza kandi\n" +
                "akunda gusabana.",
            monkeyTxt: "Inkende ntashobora gufasha gushishikarira, no gushaka kwemeza no kugira uruhare\n" +
                "muguhindura abandi. Ashaka kwisanzura mu kuvuga no gutegwa amatwi. Avugana\n" +
                "n’abandi mu buryo bushimishije, bweruye kandi agaragaza amarangamutima ye. Buri\n" +
                "gihe aba ashakisha kwakirwa no kwemerwa na mugenzi we bavugana. Yishimira\n" +
                "gukorana n’abandi. Aratekereza mu gihe arimo kuvuga ku buryo ashobora kuba\n" +
                "yavuguruza ibyo bitekerezo bye. Inkuru ze zishobora gushishikaza no gukurura\n" +
                "abandi mu buryo bworoshye. Ntatinda ku nkuru imwe, ava ku nkuru ajya ku yindi.\n" +
                "Ibikorwa ndetse n’ibyemezo bye akenshi bifatirwaho. Ibisobanuro byimbitse,\n" +
                "kunonosora no kugenzura bimubangamira mu guhanga udushya twe. Imbaraga ze\n" +
                "akenshi azipfusha ubusa kuko azitatanyiriza mu bikorwa byinshi cyane cyangwa\n" +
                "akaba adafite intego isobanutse mu mutwe.",
            monkeySlogan1: "Intego ye:",
            monkeySlogan2: "«Reka twishimane! Byari bishimishije!»",
            pandaTitle: "«Panda»",
            pandaGrayTxt: "Panda akunda ibimukikije bihamye, byateganijwe ndetse bifite gahunda, akunda\n" +
                "umwuka utuje kandi wuje urugwiro.",
            pandaTxt: "Guhamanya n’abandi n’umwuka mwiza w’itsinda bifite umwanya wa mbere kuri we.\n" +
                "Ashaka gushyigikira abandi no guharanira umubano mwiza. Amasezerano\n" +
                "asobanutse kandi n’inzira z’ imikorere zateganijwe bimuha umutekano akeneye.\n" +
                "Ashobora kwishimira kubana n’abandi agahitamo gushobora gukora akazi ke mu\n" +
                "mutuzo, ariko akaba yagendera ku muvuduko w’ abandi kugira ngo abashe\n" +
                "gukurikiza amabwiriza y’akazi. Umuntu ashobora kwizera ko inshingano zizakorwa\n" +
                "neza aramutse uzishinze panda. Panda arangwa no kumenya guteganya kandi\n" +
                "akora akazi ke intambwe ku yindi. Panda ntabwo akunda kuba ku karubanda,\n" +
                "ahubwo yirinda kwigaragaza neza. Akunda gukorana n’abantu igihe cyose hari\n" +
                "umwuka mwiza mu kazi. Iyo abandi bantu bakeneye ubufasha bwe, panda, ubundi\n" +
                "ugaragara nk’umunebwe, bwa bunebwe bwe abuhinduramo imbaraga zihishe.",
            pandaSlogan1: "Intego ye:",
            pandaSlogan2: "«Umuntu wese ameze neza! Dufite ibihe byiza hamwe!»",
            beeTitle: "«Uruyuki»",
            beeGrayTxt: "Yifuza ko ibikorwa bye byiza byashimwa. Ashishikazwa n’imibare, ibifatika, n’ibintu\n" +
                "biri byo.",
            beeTxt: "Uruyuki ashishikazwa n’ubuziranenge n’ibisabwa kw’ireme. Kugira ngo abigereho,\n" +
                "akunda gusesengura ibintu bikenewe, apima ibyiza n’ibibi no kuvuga aziga kandi mu\n" +
                "buryo bwifata. Ashaka rwose gukora ikintu gikwiye «neza», yirinda amahane no\n" +
                "kunegura, kandi yitwararika ikinoze kandi n’icyuzuye. Ateganya neza mu buryo\n" +
                "bunoze kandi akazirikana buri kantu kose, ariko rero rimwe na rimwe azimirira muri\n" +
                "uko gushaka kunoza bikabije aho gukora ibindi bintu by’ingenzi. Yumva aguwe neza\n" +
                "iyo ibyateganijwe bisobanuwe neza, kandi ikiruta byose, byanditswe mu bitabo\n" +
                "byagenewe gusobanura uko ibintu bigomba gukorwa. Ntagubwa neza mu bihe\n" +
                "byuzuye amarangamutima kandi ahitamo impaka zigendeye ku bifatika kandi\n" +
                "zumvikana. Atandukanya rwose iby’ubuzima bwe bwite n’akazi. Kubera ko akenshi\n" +
                "usanga adashamaduka kandi akifata kandi ntakunde kugaragaza amarangamutima\n" +
                "ye, bakunze kumufata nk utagira impuhwe kandi ufite umutima ukomeye, nubwo\n" +
                "akenshi biba atari byo na gato: nubwo umuntu adashobora kubibona uburyo\n" +
                "bugaragarira amaso, akenshi agira umutima woroshye kandi akaba yanakomereka\n" +
                "mu buryo bworoshye. Inzuki zishimira gukorana n’abandi bantu bafite gahunda kandi\n" +
                "nabo bafite amahame yo ku rwego rwo hejuru. Ntabwo bagira ishyaka ryinshi mu\n" +
                "kazi, ahubwo cyane cyane bakenera ibintu bibatera imbaraga byo hanze, ariko niba\n" +
                "ubushake bwabo bwo gukemura ikibazo bwabyutse, bashobora kwizirika ku kintu\n" +
                "ntagutezuka na gato kugeza gikemutse burundu.",
            beeSlogan1: "Intego ye:",
            beeSlogan2: "«Bigomba gukorwa neza. Bigomba guhura. Akazi gahebuje!»",
        }
    },
    "mongol": {
        header: {
            loginBtn: "Login",
            changeLangTxt: "Change language",
            adminPage: "Страница админа",
            logoutBtn: "Logout"
        },
        admin: {
            delQuestion: "Бүх үр дүнг устгах уу?",
            sign: "Enter",
            passMsg: "Enter password:"
        },
        auth: {
            name: "Нэр:",
            surname: "Овог:",
            email: "Цахим хаяг:",
            country: "Орон сонгох:",
            namePlace: "Нэр",
            surnamePlace: "Овог",
            emailPlace: "qwerty@mail.ru",
            countryPlace: "Орон сонгох",
            loginBtn: "Эхлэх"
        },
        main: {
            welcomeTitle: "Хувь хүний зан төлөвийг тодорхойлох сорил.",
            welcomeText: "Энэхүү онлайн асуулга нь өөрийгөө болон бусдыг илүү сайн таньж ойлгох болон бид хэн бэ, хэрхэн бие биеэ ойлгон мэдэрч бусадтай зөв харилцан тэдэнд нөлөөлж чадах вэ гэдэгт тусална. Товчоор хэлэхэд та өөрийнхөө сул болон давуу талуудыг өөр шинэ өнцгөөс олж харах болно.",
            anketaInfo: "Энэхүү асуулга 15 асуулттай бөгөөд асуулгыг бөглөхөд ердөө 7 минут л зарцуулагдана. Та асуултуудад үнэн зөв, нээлттэй хариулна уу.",
            inAnketBtn: "Асуулга руу орох",
            info1: "",
            infoLink: "BPN Mongolia",
            infoLinkPath: "https://bpn.mn/home",
            info2: " – с энэхүү асуулгыг санал болгож байгаа бөгөөд бизнесээ амжилттай эрхлэхэд тань туслах болно!"
        },
        qInfo: {
            first: "Дараах хэсэгт тус бүр дөрвөн асуулт бүхий 15 сэдэвчилсэн бүлгийг танд толилуулж байна.",
            second: "Асуулт болгонд доорх хариултуудаас өөрт хамгийн их тохирч байгаагаар нь дараах үнэлгээг өгнө үү:",
            threeOne: "„хамгийн сайн тохирч байна“ = 4 оноо",
            threeTwo: "„тохирч байна“ = 3 оноо",
            threeThree: "„тохирохгүй“ = 2 оноо",
            threeFour: "„огт тохирохгүй“ = 1 оноо",
            fourty: "Асуулт болгоныг 1, 2, 3, 4 гэсэн оноонуудаар тус бүр нэг удаа үнэлнэ.",
            fifth: "Энэхүү сорилыг бөглөхдөө ажил мэргэжил эсвэл хувь хүнийхээ зүгээс бөглөж болох бөгөөд та аль нэгийг нь л сонгон бөглөнө!",
            inAnketBtn: "Эхлүүлэх",
            inBackBtn: "Эхлэл руу буцах"
        },
        question: {
            qInfo1: "Асуулт ",
            qInfo2: " -15",
            inNextBtn: "үргэлжлүүлэх",
            inStartBtn: "Эхлэл рүү буцах",
            inBackBtn: "Буцах",
            badMessageTxT: "There are unmarked questions on the page",
            "4Punkt": "хамгийн сайн тохирч байна",
            "3Punkt": "тохирч байна",
            "2Punkt": "тохирохгүй",
            "1Punkt": "огт тохирохгүй",
            1: [{
                id: 1,
                title: "Би байнга ажилладаг",
            },
                {
                    id: 2,
                    title: "Би ажлаа баяр хөөртэйгөөр хийдэг",
                },
                {
                    id: 3,
                    title: "Би үр дүнд хурдан хүрдэг",
                },
                {
                    id: 4,
                    title: "Би ажлаа яг сайн хийдэг",
                }
            ],
            2: [{
                id: 1,
                title: "Юу болсон тухайгаа би ярих дуртай",
            },
                {
                    id: 2,
                    title: "Би сайн сонсож байгаад зөв асуулт тавьдаг",
                },
                {
                    id: 3,
                    title: "Би сонсож байгаад сайн зөвлөгөө өгдөг",
                },
                {
                    id: 4,
                    title: "Би анхаарлаа төвлөрүүлж, тодорхой ярьдаг.",
                }
            ],
            3: [{
                id: 1,
                title: "Би шинэ зүйл хийх дуртай.",
            },
                {
                    id: 2,
                    title: "Би хэцүү ажлыг хурдан хийж гүйцэтгэдэг.",
                },
                {
                    id: 3,
                    title: "Би мэдээллийн үнэн зөв эсэхийг нарийвчлан шалгаж хянамгай ажилладаг.",
                },
                {
                    id: 4,
                    title: "Би сайн баг хамт олонтой ажиллах дуртай",
                }
            ],
            4: [{
                id: 1,
                title: "Би хүнлэг",
            },
                {
                    id: 2,
                    title: "Би хүсэл зорилгынхоо төлөө тэмцдэг",
                },
                {
                    id: 3,
                    title: "Би аливаа зүйлд тактиктай, эв дүйтэй ханддаг",
                },
                {
                    id: 4,
                    title: "Би шинийг санаачлагч",
                }
            ],
            5: [{
                id: 1,
                title: "Би бусадтай байнга өрсөлддөг",
            },
                {
                    id: 2,
                    title: "Би тэнцвэрт байдлыг бий болгохыг эрмэлздэг",
                },
                {
                    id: 3,
                    title: "Би нийтэч, хөгжилтэй хүмүүстэй байх дуртай",
                },
                {
                    id: 4,
                    title: "Хамт олон дундаа дүрэм журмыг дагаж мөрдөхийг эрмэлздэг",
                }
            ],
            6: [{
                id: 1,
                title: "Би шийдвэр гаргахаасаа өмнө бусдаас асуудаг",
            },
                {
                    id: 2,
                    title: "Би зөн совингоороо гэнэтийн шийдвэр гаргадаг",
                },
                {
                    id: 3,
                    title: "Би бас таагүй шийдвэрийг хурдан гаргадаг",
                },
                {
                    id: 4,
                    title: "Би шийдвэр гаргахаасаа өмнө баримт цуглуулж дүн шинжилгээ хийдэг",
                }
            ],
            7: [{
                id: 1,
                title: "Би дуртайяа бусадтай яриа өрнүүлж мөн танихгүй хүнтэй ч хөгжилтэй зүйл ярих дуртай",
            },
                {
                    id: 2,
                    title: "Би бодитой, логиктой ярьдаг",
                },
                {
                    id: 3,
                    title: "Яриан дундуураа бусад өөр хүмүүстэй ярихыг оролддог",
                },
                {
                    id: 4,
                    title: "Би яриа өрнүүлж, гол асуудалдаа хурдан ордог",
                }
            ],
            8: [{
                id: 1,
                title: "Би өөрийгөө болон мэдрэмжээ сайн хянаж чаддаг",
            },
                {
                    id: 2,
                    title: "Ихэнх хүмүүс намайг эелдэг гэж хардаг",
                },
                {
                    id: 3,
                    title: "Юм хэлээгүй байсан ч хүмүүсийн ямар байгааг би мэдэрдэг",
                },
                {
                    id: 4,
                    title: "Бусад хүмүүс өөрөөр харж байсан ч би өөрийн үзэл бодолдоо үнэнч байдаг",
                }
            ],
            9: [{
                id: 1,
                title: "Зөрчлийн үед би бодитой дүгнэлт хийдэг",
            },
                {
                    id: 2,
                    title: "Би зөрчлөөс зайлсхийх эсвэл шийдвэрлэхийг эрмэлздэг",
                },
                {
                    id: 3,
                    title: "Би зөрчлөөс айхгүйгээр шууд оролцдог",
                },
                {
                    id: 4,
                    title: "Зөрчил бол энгийн зүйл учир би хурдан мартдаг",
                }
            ],
            10: [{
                id: 1,
                title: "Хүмүүс намайг найдвартай гэж үздэг",
            },
                {
                    id: 2,
                    title: "Хүмүүс намайг баяр хөөртэй гэж боддог",
                },
                {
                    id: 3,
                    title: "Хүмүүс намайг ухамсартай гэж боддог",
                },
                {
                    id: 4,
                    title: "Хүмүүс намайг шийдэмгий гэж боддог",
                }
            ],
            11: [{
                id: 1,
                title: "Би олны өмнө ярих дуртай",
            },
                {
                    id: 2,
                    title: "Би хүмүүстэй илүү ойрхон харилцахын тулд 1 юм уу 2 хүнтэй л ярилцахыг илүүд үздэг",
                },
                {
                    id: 3,
                    title: "Би баримт болон мэдлэгт тулгуурлан ярьдаг",
                },
                {
                    id: 4,
                    title: "Би аливаа зүйлд нөлөө үзүүлж, бусдыг ямарваа нэгэн зүйл хийхэд хүргэдэг",
                }
            ],
            12: [{
                id: 1,
                title: "Миний хувьд үр дүн чухал",
            },
                {
                    id: 2,
                    title: "Миний хувьд эв нэгдэл чухал",
                },
                {
                    id: 3,
                    title: "Миний хувьд шинэ зүйл болон аливаа өөрчлөлт чухал",
                },
                {
                    id: 4,
                    title: "Миний хувьд нарийвчлал чухал",
                }
            ],
            13: [{
                id: 1,
                title: "Би хүмүүсийг өөрийн талд оруулж чаддаг",
            },
                {
                    id: 2,
                    title: "Юу ч хийхгүй байх надад хэцүү байдаг",
                },
                {
                    id: 3,
                    title: "Би бусдын асуудал болон бэрхшээлийг ойлгодог",
                },
                {
                    id: 4,
                    title: "Би илүү зай барьсан мөн чимээгүй хүн/a",
                }
            ],
            14: [{
                id: 1,
                title: "Би тууштай хүн",
            },
                {
                    id: 2,
                    title: "Би болгоомжтой хүн",
                },
                {
                    id: 3,
                    title: "Би урам зоригтой хүн",
                },
                {
                    id: 4,
                    title: "Би аливааг хийж дуустал тууштай ханддаг",
                }
            ],
            15: [{
                id: 1,
                title: "Би аливаад хяналттай хандахыг хүсдэг",
            },
                {
                    id: 2,
                    title: "Би хөгжилтэй байхыг хүсдэг",
                },
                {
                    id: 3,
                    title: "Би бага хүчин чармайлт гаргахыг хүсдэг",
                },
                {
                    id: 4,
                    title: "Би аливааг зөв хийхийг хүсдэг",
                }
            ]
        },
        result: {
            mailMsg: "Мэдээлэл таны цахим хаягаар илгээгдлээ.",
            goodMessageAnswer: "Мэдээлэл таны цахим хаягаар илгээгдлээ.",
            goodMessageAnswer2: "Хувь хүний зан чанарыг тодорхойлох асуулгын доорх линкийг найзууддаа илгээх:",
            title: "Үнэлгээ",
            eagleBall: "Нийт оноо «Бүргэд»",
            beeBall: "Нийт оноо «Зөгий»",
            monkeyBall: "Нийт оноо «Сармагчин»",
            pandaBall: "Нийт оноо «Панда»",
            type: "Төрөл",
            balls: "Оноо",
            percents: "Хувь",
            resultTxt1: "36 –с дээш оноотой, өөрөөр хэлбэл дээр дүрсэлсэн дөрвөлжний гадна талд байгаа шинж чанаруудыг илүү боломжийн харин 36 -с доош оноо бүхий шинж чанаруудыг жаахан сул хэмээн дүгнэж болно. Дээрх зан чанаруудын аль аль нь танд байгааг энэ сорилоос олж харах болно. Харин та дан ганц «бүргэд» эсвэл «зөгий» -ний шинж чанартай байна гэж байхгүй.",
            resultTxt12: "Таны хувь хүний зан чанарын дүрслэл хэдий чинээ илүү тэлсэн байна төдий чинээ та өөрийгөө",
            resultTxtLink: "энэхүү зан чанарын хандлагын тодорхойлолтоос",
            resultTxt2: "олох болно. Хэрвээ зан чанарын төрөл бүрд авсан оноонууд тань хоорондоо тэнцүү байвал дөрвөн зан чанарын зөвхөн аль нэг нь таныг илэрхийлж болно эсвэл тухайн үеийн нөхцөл байдлаас хамаараад та өөр өөр зан төлөвийн хандлагыг ч бас гаргаж болох юм.",
            resultTxtBold: "Хүн болгон өөр өөрийн гэсэн онцлогтой! Энэхүү зан төлөвийн тодорхойлолт таны өвөрмөц онцлогийг тодотгон гаргаж ирэх бөгөөд энэ нь аль нэг зан чанарыг сайн эсвэл муу хэмээн дөвийлгөн харуулж байгаа зүйл огт биш юм. Харин таны зан чанарын төлөв байдлыг бусад хүмүүс хэрхэн хүлээн авч байна вэ гэдгийг л харуулдаг. Зан төлөвийн тодорхойлолтыг линктэй холбох",
            resultTxt3: "Хэрвээ та хувь хүний зан төлөвийн хандлагын талаар илүү ихийг мэдэхийг хүсвэл BPN - ийн",
            resultTxt4: "Хамт олноо удирдахуй",
            resultTxt5: "сургалтад бүртгүүлээрэй.",
            resultBpnLink: "https://bpn.mn/business-academy/summary",
            backOnBtnLink: "https://bpn.mn/home",
            sendMailBtn: "Үнэлгээг pdf -р илгээх",
            shareWithFriendsBtn: "Асуулгыг найзуудтайгаа хуваалцах",
            restartBtn: "Асуулгыг дахин бөглөх",
            backOnMainBtn: "BPN-ийн эхлэл рүү буцах",
            emailHead: "Share this questionnaire",
            emailMessage: "Enter mail:",
            emailSuccessTxt: "Was sent!",
            emailSendBtn: "Send",
            emailLinkTxt: "Асуулгын хуудсыг зан чанарын төрлөөр нь холбоно уу",
            emailPlaceholder: "A message will be sent to this mail.",
            emailMessageToFriend: "Хувь хүний зан төлөвийн тодорхойлолт. Business Professionals Network (BPN).\nСайн байна уу! Энэхүү хувь хүний зан төлөвийн тодорхойлолтийн асуулгуудыг бүрэн бөглөсөн байх шаардлагатай: Асуултуудыг дараах линкээр холбогдож авна уу"
        },
        fourTendentions: {
            title: "Зан төлөвийн хандлагын тодорхойлолт",
            eagleTitle: "Бүргэд",
            eagleGrayTxt: "Бүргэд хийж буй болон хүрсэн зүйлээ бусдаар хүлээн зөвшөөрүүлэхийг хүсдэг. Тэд тэмцэл мөн ялалтаасаа урам зориг авдаг.",
            eagleTxt: "Бүргэд өөртөө маш итгэлтэй, үр дүнд чиглэсэн байдаг бөгөөд аль болох хурдан үр дүнд хүрэхийг эрмэлздэг. Хүссэн үр дүндээ хүрэхийн тулд зогсолтгүй тэмүүлдэг. Саад бэрхшээл, хүндрэл түүнийг илүү их амжилтад хөтөлдөг. Тэрээр өрсөлдөөн, эсэргүүцлийг даван туулж, асуудлыг зоригтойгоор шийдвэрлэж чадвал түүнээсээ маш их сэтгэл ханамжийг авдаг. Бас аливаа зүйлийн учрыг олж хайрцгаас гадуур сэтгэж чаддаг. Бүргэд аливаа асуудлын гол утга учрыг хурдан олдог, тууштай, шууд(заримдаа жаахан бөөрөнхий), нээлттэй байдаг. Бусад хүмүүс анхаарлаа хандуулан харилцаж асуудлыг хурдан шийдвэрлэхэд тэр дуртай байдаг. Бүргэд олон төрлийн, шинэ ажилд дуртай бөгөөд өөрийнхөө эзэн нь байхыг хүсдэг. Тэрээр юу хүсэж байгаагаа мэддэг, хяналтыг гартаа авч эргэн тойрныхон болон бусдын юу хийхийг нь тодорхойлдог. Тэр өөрөөсөө болон бусдаас илүү ихийг шаардаж заримдаа ч бүр хэтрүүлэх тохиолдол гардаг. Учир нь бусад хүмүүс өөртэй нь адил эрч хүч, энергитэй байдаггүй гэдгийг мэддэггүй.",
            eagleSlogan1: "Түүний уриа:",
            eagleSlogan2: "«Дууссан! Зорилгодоо хүрсэн! Бүх зүйл хяналтад байна!»",
            monkeyTitle: "Сармагчин",
            monkeyGrayTxt: 'Өөрийн байгаа байдал, хандлагаараа бусдад таалагдахыг хүсдэг. Тэр хөгжилтэй байж хүмүүстэй холбоо тогтоох дуртай.',
            monkeyTxt: "Сармагчин бусдыг урам зоригжуулж, итгэн үнэмшүүлж мөн тэдэнд нөлөөлөхийг хүсдэг. Мөн түүнчлэн тэр өөрийгөө маш нээлттэйгээр илэрхийлж, бусдад мэдэгдэхийг хүсдэг. Хүмүүстэй сэтгэл хөдлөм, нээлттэй харилцаж өөрийгөө илэрхийлдэг. Үүний зэрэгцээ тэр өөрийгөө хамтрагчаараа хүлээн зөвшөөрүүлж байнга ямар нэг баталгааг эрэлхийлж байдаг. Тэрээр хүмүүстэй хамтран ажиллах маш дуртай. Ярьж байхдаа өөрийнхөө санааг хаяж чаддаг гэж боддог бөгөөд хошин түүхээрээ бусдыг гайхшируулж тэднийг\n" +
                "асуудалгүйгээр өөртөө татаж чаддаг. Сармагчин ийш тийшээ үсчин нэг сэдэв дээрээ\n" +
                "ховорхон удаан, тогтвортой байдаг. Түүний хийж буй үйлдлүүд, гаргаж буй шийдвэрүүд\n" +
                "ихэвчлэн маш гэнэтийн байдаг. Нарийвчлал, хэсэгчилсэн ажил эсвэл аливаа хяналт\n" +
                "түүний бүтээлч байдлыг сааруулдаг. Тэрээр тавьсан тодорхой зорилгогүй эсвэл маш\n" +
                "олон ажлыг нэг дор хийж байдаг учраас ихэвчлэн энерги, эрч хүчээ хурдан алддаг.",
            monkeySlogan1: "Түүний уриа:",
            monkeySlogan2: "«Зугаатай, хөгжилтэй байцгаая! Хөгжилтэй, зугаатай байлаа!»",
            pandaTitle: "Панда",
            pandaGrayTxt: "Панда тогтвортой, урьдчилан таамаглаж болохуйц, эмх замбараатай байдлыг илүүд үздэг, тайван найрсаг уур амьсгалд дуртай.",
            pandaTxt: "Түүний хувьд эв найрамдал, багийн сэтгэл зүй нэн тэргүүнд тавигддаг. Тэр бусадтай сайн харилцаа үүсгэж тэднийг дэмжихийг хүсдэг. Тодорхой, шударга харилцаа, урьдчилан таамаглах нь түүнд аюулгүй байдлыг бий болгодог. Тэрээр ажлаа амар тайван гүйцэтгэхийн тулд ажлын хурдаа дүрэм журамд нийцүүлэн тохируулан ажилладаг. Харин та пандад хуваарилсан ажлынхаа гүйцэтгэлд санаа зовохгүй байж болно. Тэр өөрийгөө маш сайн төлөвлөгч гэж үздэг бөгөөд үүрэгт ажлаа алхам алхмаар гүйцэтгэдэг. Панда олны анхаарлын төвд байх дургүй тул өөрийгөө хэт дөвийлгөж харуулахаас зайлсхийдэг. Ажлын уур амьсгал таатай үед тэрээр хүмүүстэй дуртайяа хамтран ажилладаг. Бусад хүмүүст түүний тусламж хэрэгтэй үед залхуу пандагийн нуугдмал хүчийг гаргадаг.",
            pandaSlogan1: "Түүний уриа:",
            pandaSlogan2: "«Бид бүгд сайн байна! Бид хамтдаа цагийг сайхан өнгөрүүлж байна!»",
            beeTitle: "Зөгий",
            beeGrayTxt: "Өөрийн гайхалтай гүйцэтгэлийг бусдаар хүлээн зөвшөөрүүлэхийг хүсдэг. Тэрээр тоо баримт, нарийвчлалд тулгуурлан ажлаа гүйцэтгэж түүнээсээ урам зориг авдаг.",
            beeTxt: "Зөгий стандарт болон чанарын шаардлагад тулгуурлан ажилладаг. Үүний тулд тэд\n" +
                "шаардлагатай гэсэн зүйлдээ дүн шинжилгээ хийж давуу болон сул талыг харьцуулан\n" +
                "дипломат, ухаалаг байдлаар хандах дуртай байдаг. Зөгий зөв зүйлийг зайлшгүй «зөв»\n" +
                "хийж, уур уцаар, шүүмжлэлээс зайлсхийж нарийвчлалд анхаарлаа хандуулахыг\n" +
                "үнэхээр хүсдэг. Аливааг нарийн төлөвлөж, бүхий л нарийн ширийн хэсгүүдийг\n" +
                "харгалзан үздэг. Заримдаа хэт төгс байдалд тэмүүлснээсээ болж бусад чухал\n" +
                "зүйлүүдийг алдах ч тохиолдол гардаг. Аливаа хүлээлтүүд нь тодорхой байж үйл явцыг\n" +
                "бичгээр үйлдэж баталгаажсан байхад зөгий дуртай байдаг. Тэрээр сэтгэл хөдлөл ихтэй\n" +
                "нөхцөл байдалд тийм ч таатай байдаггүй бөгөөд бодитой, логик аргументуудыг\n" +
                "чухалчилдаг. Хувийн болон албаны ажлыг хатуу ялгаж салган авч үздэг. Хүйтэн\n" +
                "хөндий, зай барьж сэтгэл хөдлөлөө бараг л бусдад харуулдаггүй учраас түүнийг\n" +
                "мэдрэмжгүй, зүрх сэтгэлгүй гэж тодорхойлох нь ч байна. Харин тэд бодит байдал дээр\n" +
                "эсрэгээрээ байдаг бөгөөд тэдний мэдрэмтгий, амархан гомддог байдлыг гаднаас нь\n" +
                "хараад тодорхойлж чаддаггүй байна. Зөгийнүүд зохион байгуулалт сайтай, шаардлага\n" +
                "өндөртэй хүмүүстэй хамтран ажиллах дуртай байдаг. Тэд аливаа зүйлийг их хүсэл\n" +
                "тэмүүллээр хийдэггүй бөгөөд тэдэнд ихэвчлэн гаднын хөдөлгөгч хүч шаардлагатай\n" +
                "болдог. Гэхдээ тэдний сонирхлыг өдөөж чадсан бол тухайн асуудлыг бүрэн шийдэгдтэл\n" +
                "тууштай ханддаг.",
            beeSlogan1: "Тэдний уриа:",
            beeSlogan2: "«Зайлшгүй зөв хийх ёстой. Яг тодорхой байх ёстой. Төгс байх!»",
        }
    },
    "spanish": {
        header: {
            loginBtn: "Login",
            changeLangTxt: "Change language",
            adminPage: "Страница админа",
            logoutBtn: "Logout"
        },
        admin: {
            delQuestion: "¿Está seguro de que desea eliminar todos los resultados?",
            sign: "Enter",
            passMsg: "Enter password:"
        },
        auth: {
            name: "Su nombre:",
            surname: "Su appellido:",
            email: "Correo electrónico:",
            country: "Country:",
            namePlace: "Nombre",
            surnamePlace: "Apellido",
            emailPlace: "qwerty@mail.ru",
            countryPlace: "Seleccionar país:",
            loginBtn: "Iniciar"
        },
        main: {
            welcomeTitle: "¡Bienvenidos al cuestionario de perfil de personalidad!  ",
            welcomeText: "El propósito de este cuestionario en línea es ayudarle a conocerse mejor a sí mismo y a los demás, a entender quiénes somos, cómo actuamos y sentimos y cómo nos perciben otras personas. En resumen: a través de este cuestionario usted obtendrá una visión completamente diferente de sus propias fortalezas y debilidades.",
            anketaInfo: "El cuestionario consta de 15 preguntas y llenarlo toma unos 7 minutos. Responda de forma honesta y espontánea.",
            inAnketBtn: "Haga clic aquí para acceder al cuestionario",
            info1: "Este cuestionario ha sido elaborado por ",
            infoLink: "BPN Nicaragua:",
            infoLinkPath: "https://bpnnicaragua.com/home",
            info2: " Por un fuerte espíritu empresarial en BPN Nicaragua!"
        },
        qInfo: {
            first: "A continuación, se presentan 15 grupos de oraciones ordenados por tema, cada uno con cuatro oraciones.",
            second: "En cada grupo de oraciones, seleccione aquella con la que esté:",
            threeOne: "“muy de acuerdo” = 4 puntos",
            threeTwo: "“bastante de acuerdo” = 3 puntos",
            threeThree: "“algo de acuerdo” = 2 puntos",
            threeFour: "“nada de acuerdo” = 1 punto",
            fourty: "Esto significa que en cada grupo de cuatro los números 1, 2, 3 y 4 deben aparecer solamente una vez.",
            fifth: "Al responder, piense en un entorno concreto. Independientemente de si rellena el cuestionario en función de una situación laboral o privada, ¡es importante que seleccione un entorno específico!",
            inAnketBtn: "Ir al cuestionario",
            inBackBtn: "Volver al principio"
        },
        question: {
            qInfo1: "Pregunta",
            qInfo2: "de 15",
            inNextBtn: "Continuar",
            inStartBtn: "Volver al principio",
            inBackBtn: "Volver",
            badMessageTxT: "There are unmarked questions on the page",
            "4Punkt": "muy de acuerdo",
            "3Punkt": "bastante de acuerdo",
            "2Punkt": "algo de acuerdo",
            "1Punkt": "nada de acuerdo",
            1: [{
                id: 1,
                title: "Trabajo de forma constante",
            },
                {
                    id: 2,
                    title: "Hago mi trabajo con entusiasmo",
                },
                {
                    id: 3,
                    title: "Obtengo resultados rápidamente",
                },
                {
                    id: 4,
                    title: "Realizo mi trabajo de manera exacta",
                }
            ],
            2: [{
                id: 1,
                title: "Me gusta contar lo que me sucedió",
            },
                {
                    id: 2,
                    title: "Escucho atentamente y hago las preguntas correctas",
                },
                {
                    id: 3,
                    title: "Me gusta escuchar y dar consejos que ayuden",
                },
                {
                    id: 4,
                    title: "Hablo de forma clara y focalizada",
                }
            ],
            3: [{
                id: 1,
                title: "Me gusta emprender cosas nuevas",
            },
                {
                    id: 2,
                    title: "Termino rápidamente las tareas desafiantes",
                },
                {
                    id: 3,
                    title: "Trabajo con precisión y me aseguro de que todos los detalles sean correctos",
                },
                {
                    id: 4,
                    title: "Me gusta trabajar en un equipo en el que todos se sienten bien",
                }
            ],
            4: [{
                id: 1,
                title: "Soy solidario/a",
            },
                {
                    id: 2,
                    title: "Tengo fuerza de voluntad",
                },
                {
                    id: 3,
                    title: "Tengo mucho tacto",
                },
                {
                    id: 4,
                    title: "Soy ingenioso/a",
                }
            ],
            5: [{
                id: 1,
                title: "Suelo ser competitivo/a con los demás",
            },
                {
                    id: 2,
                    title: "Trato de mantener el equilibrio en un grupo",
                },
                {
                    id: 3,
                    title: "Me gusta tener reuniones sociales y alegres",
                },
                {
                    id: 4,
                    title: "Dentro de un grupo, procuro que se cumplan las normas",
                }
            ],
            6: [{
                id: 1,
                title: "Antes de decidir, consulto a otras personas",
            },
                {
                    id: 2,
                    title: "Decido de forma espontánea e intuitiva",
                },
                {
                    id: 3,
                    title: "También las decisiones desagradables las tomo rápidamente",
                },
                {
                    id: 4,
                    title: "Recopilo y analizo los hechos antes de decidir",
                }
            ],
            7: [{
                id: 1,
                title: "Me gusta entablar conversaciones y contar historias graciosas incluso a desconocidos",
            },
                {
                    id: 2,
                    title: "Hablo de manera objetiva y lógica",
                },
                {
                    id: 3,
                    title: "En una conversación trato de responder considerando a la otra persona",
                },
                {
                    id: 4,
                    title: "Cuando mantengo conversaciones voy rápidamente al grano",
                }
            ],
            8: [{
                id: 1,
                title: "Puedo controlar bien mis sentimientos y a mí mismo",
            },
                {
                    id: 2,
                    title: "En general, le caigo bien a la mayoría de la gente",
                },
                {
                    id: 3,
                    title: "Me doy cuenta de cómo se sienten otras personas, aunque no digan nada",
                },
                {
                    id: 4,
                    title: "Me mantengo fiel a mis principios, aunque todo el mundo opine diferente",
                }
            ],
            9: [{
                id: 1,
                title: "En los conflictos argumento de manera objetiva",
            },
                {
                    id: 2,
                    title: "Procuro evitar los conflictos o resolverlos",
                },
                {
                    id: 3,
                    title: "Abordo los conflictos de forma directa y sin temor",
                },
                {
                    id: 4,
                    title: "Los conflictos son algo común, por eso los dejo atrás rápidamente",
                }
            ],
            10: [{
                id: 1,
                title: "La gente considera que soy fiable",
            },
                {
                    id: 2,
                    title: "La gente me percibe como una persona entusiasta",
                },
                {
                    id: 3,
                    title: "La gente me percibe como alguien concienzudo",
                },
                {
                    id: 4,
                    title: "La gente me percibe como una persona decidida",
                }
            ],
            11: [{
                id: 1,
                title: "Me gusta hablar delante de mucha gente",
            },
                {
                    id: 2,
                    title: "Prefiero hablar con sólo 1 o 2 personas para poder considerarlas debidamente",
                },
                {
                    id: 3,
                    title: "Hablo en base a hechos y conocimientos para poder convencer",
                },
                {
                    id: 4,
                    title: "Hablo para lograr algo y hacer que la gente haga algo.",
                }
            ],
            12: [{
                id: 1,
                title: "Los resultados son importantes para mí",
            },
                {
                    id: 2,
                    title: "La armonía es importante para mí",
                },
                {
                    id: 3,
                    title: "La novedad y la variedad son importantes para mí",
                },
                {
                    id: 4,
                    title: "La exactitud es importante para mí",
                }
            ],
            13: [{
                id: 1,
                title: "Puedo conquistar a la gente fácilmente para una causa",
            },
                {
                    id: 2,
                    title: "Me resulta difícil estar sin hacer nada",
                },
                {
                    id: 3,
                    title: "Soy comprensivo/a con las preocupaciones y problemas de los demás",
                },
                {
                    id: 4,
                    title: "Soy más bien reservado/a",
                }
            ],
            14: [{
                id: 1,
                title: "Soy una persona estable",
            },
                {
                    id: 2,
                    title: "Soy una persona cuidadosa",
                },
                {
                    id: 3,
                    title: "Soy una persona inspiradora",
                },
                {
                    id: 4,
                    title: "Persevero hasta cumplir un objetivo",
                }
            ],
            15: [{
                id: 1,
                title: "Quiero mantener el control",
            },
                {
                    id: 2,
                    title: "Quiero divertirme",
                },
                {
                    id: 3,
                    title: "Quiero evitar esfuerzos innecesarios",
                },
                {
                    id: 4,
                    title: "Quiero que esté correcto",
                }
            ]
        },
        result: {
            mailMsg: "Message success sending!",
            goodMessageAnswer: "El mensaje se envió a su correo electrónico.",
            goodMessageAnswer2: "También puede compartir este cuestionario con amigos haciendo clic en el enlace a continuación.",
            title: "Evaluación del perfil de personalidad",
            eagleBall: "Total de puntos para el tipo de personalidad \"Águila\"",
            beeBall: "Total de puntos para el tipo de personalidad \"Abeja\"",
            monkeyBall: "Total de puntos para el tipo de personalidad \"Mono\"",
            pandaBall: "Total de puntos para el tipo de personalidad \"Panda\"",
            type: "Tipo",
            balls: "Puntos",
            percents: "Porcentaje",
            resultTxt1: "Las características que superan el valor de 36, es decir, que se encuentran fuera del cuadro dibujado, tienden a ser más percibidas como rasgos presentes, mientras que las que se encuentran por debajo del valor de 36 tienden más a ser percibidas como una carencia. Usted podrá observar que tiene elementos de todas las tendencias de comportamiento. Es decir, nadie es exclusivamente un \"águila\" o una \"abeja\".",
            resultTxt12: "Cuanto más marcados sean los extremos de su perfil de personalidad, más se reconocerá en las",
            resultTxtLink: "descripciones de cada una de las cuatro tendencias de comportamiento.",
            resultTxt2: "Si sus puntuaciones en los cuatro tipos de personalidad están relativamente equilibradas, entonces coincidirá sólo con algunas de las afirmaciones o se comportará de forma diferente en función de cada situación.",
            resultTxtBold: "Cada persona es única. Su perfil de personalidad saca a relucir esta singularidad y eso no es ni bueno ni malo. Simplemente es un reflejo de su personalidad, de cómo lo perciben los demás.",
            resultTxt3: "Si desea aprender más sobre las tendencias de comportamiento de los cuatro tipos de personalidad, inscríbase hoy mismo en el seminario sobre",
            resultTxt4: "Liderazgo y Recursos Humanos",
            resultTxt5: " de BPN.",
            resultBpnLink: "https://bpnnicaragua.com/business-academy/business-academy",
            backOnBtnLink: "https://bpnnicaragua.com",
            sendMailBtn: "Enviar la evaluación en pdf",
            shareWithFriendsBtn: "Compartir el cuestionario",
            restartBtn: "Volver a llenar el cuestionario",
            backOnMainBtn: "Volver a la página de inicio de BPN",
            emailHead: "Share this questionnaire",
            emailMessage: "Enter mail:",
            emailSuccessTxt: "Was sent!",
            emailSendBtn: "Send",
            emailLinkTxt: "Link Fragebogen Persönlichkeitsprofil",
            emailPlaceholder: "A message will be sent to this mail.",
            emailMessageToFriend: "Perfil de personalidad Business Professionals Network (BPN).\n¡Hola! Es imprescindible que rellenes este cuestionario de perfil de personalidad. Puedes encontrarlo aquí:"
        },
        fourTendentions: {
            title: "Descripciones de las cuatro tendencias de comportamiento",
            eagleTitle: "El águila",
            eagleGrayTxt: "El águila quiere recibir reconocimiento por lo que hace y por lo que logra. Los desafíos y las victorias son su motivación.",
            eagleTxt: "El águila tiene una gran confianza en sí misma, se centra en los resultados y quiere alcanzarlos lo antes posible. Siempre tiene que estar activa hasta conseguir los resultados deseados. Los retos son un estímulo para alcanzar logros aún mayores. Afronta los problemas con valentía y siente una gran satisfacción cuando consigue vencer un obstáculo o incluso a la competencia. Al mismo tiempo, cuestiona lo conocido y es capaz de pensar desde otro ángulo. El águila llega rápidamente al fondo de un asunto, es asertiva, directa, abierta (y a veces tosca). Le encanta que los demás se comuniquen de forma precisa y vayan rápidamente al grano. Al águila le gusta realizar actividades nuevas y variadas y quiere ser su propio jefe. Sabe lo que quiere, toma por supuesto el control, le gusta determinar su entorno e indica a los demás lo que tienen que hacer. Se exige mucho a sí misma, pero también a los demás, por lo que a veces puede pasarse de la raya, porque no es consciente de que no todo el mundo tiene tanta energía como ella.",
            eagleSlogan1: "Su lema es:",
            eagleSlogan2: "“¡Listo! ¡Misión cumplida! ¡Todo está bajo control!”",
            monkeyTitle: "El mono",
            monkeyGrayTxt: "El mono quiere que su forma de actuar y de comportarse le agrade a la gente. Lo motiva\n" +
                "la diversión y le gusta socializar.",
            monkeyTxt: "El mono siempre quiere motivar, convencer e influenciar a los demás. Para ello, quiere\n" +
                "hablar extensamente y que le escuchen. Habla con emoción, abiertamente y expresa sus\n" +
                "sentimientos. Al hacerlo, siempre espera la confirmación y aceptación de su interlocutor.\n" +
                "Prefiere trabajar con otros. Piensa mientras habla, de manera que va descartando sus propias ideas mientras sigue hablando. Es capaz de inspirar y cautivar a los demás con sus historias. Es errático y casi nunca se concentra en un tema durante mucho tiempo. Sus acciones y decisiones suelen ser espontáneas e intuitivas. Los detalles, la precisión y el control bloquean su creatividad. A menudo, desperdicia su energía porque se enfrasca en demasiadas actividades o no tiene un objetivo claramente definido.",
            monkeySlogan1: "Su lema es:",
            monkeySlogan2: "“¡Pasémosla bien! ¡Eso fue muy divertido!”",
            pandaTitle: "El panda",
            pandaGrayTxt: "El panda prefiere un entorno estable, predecible y ordenado, y le encanta un ambiente\n" +
                "relajado y amistoso.",
            pandaTxt: "La armonía y un buen espíritu de equipo son prioridades absolutas para él. Quiere apoyar a\n" +
                "los demás y garantizar que las relaciones sean buenas. Los acuerdos claros y justos, así\n" +
                "como los procesos predecibles, le brindan la seguridad que necesita. Disfruta pasar un rato\n" +
                "agradable con los demás y prefiere hacer su trabajo con tranquilidad, pero a la vez ajusta su\n" +
                "ritmo para cumplir con los plazos. Cuando se le asignan tareas a un panda, se puede tener\n" +
                "la certeza de que las completará. Destaca por ser un buen planificador y va realizando sus\n" +
                "tareas paso a paso. Al panda no le gusta ser el centro de atención y, por lo tanto, evita\n" +
                "lucirse demasiado. Le gusta trabajar con la gente siempre que haya un buen ambiente de\n" +
                "trabajo. Cuando otras personas necesitan su ayuda, el normalmente perezoso panda\n" +
                "despliega su fuerza interior.",
            pandaSlogan1: "Su lema es:",
            pandaSlogan2: "“¡Todos están bien! ¡Qué bien lo pasamos juntos!”",
            beeTitle: "La abeja",
            beeGrayTxt: "La abeja quiere que se reconozca su excelente trabajo. Los hechos, las cifras y la\n" +
                "precisión son su mayor motivación",
            beeTxt: "Las normas y las exigencias de calidad estimulan a la abeja. Por eso le gusta analizar lo que\n" +
                "sea necesario, sopesar los pros y los contras y comunicarse de forma diplomática y más\n" +
                "bien reservada. Quiere hacer lo correcto &quot;de forma correcta&quot;, evitar los disgustos y las\n" +
                "críticas, y presta atención a la precisión y la exactitud. Planifica con precisión y tiene en\n" +
                "cuenta todos los detalles, pero a veces se enfrasca en buscar la perfección en lugar de dar\n" +
                "importancia a otras cosas. Se siente cómoda cuando las expectativas están claramente\n" +
                "definidas y, de preferencia, escritas en una descripción del proceso. No se siente muy\n" +
                "cómoda en situaciones de gran carga emocional y prefiere los argumentos objetivos y\n" +
                "lógicos. Mantiene una estricta separación entre su vida privada y su trabajo. Como suelen\n" +
                "parecer frías y reservadas y muestran pocas emociones, a menudo se las juzga como\n" +
                "insensibles y sin corazón, aunque muchas veces ocurre todo lo contrario: aunque no se\n" +
                "perciba por fuera, suelen ser sensibles y fácilmente vulnerables. A las abejas les gusta\n" +
                "trabajar con otras personas que son organizadas y también tienen un alto nivel de exigencia.\n" +
                "Aunque no tienen tanto empuje, sino que casi siempre necesitan un estímulo externo, una\n" +
                "vez que se les despierta el apetito por un problema, pueden dedicarse a algo con mucha\n" +
                "disciplina hasta resolverlo por completo.",
            beeSlogan1: "Su lema es:",
            beeSlogan2: "“Hay que hacerlo bien. Todo tiene que ser correcto. ¡Excelente trabajo!”",
        }
    },
    "gruzian": {
        header: {
            loginBtn: "შესვლა",
            changeLangTxt: "შეცვალე ენა",
            logoutBtn: "Logout"
        },
        admin: {
            delQuestion: "ნამდვილად გსურთ შედეგების წაშლა?",
            sign: "Enter",
            passMsg: "Enter password:"
        },
        auth: {
            name: "შენი სახელი და გვარი:",
            surname: "შენი გვარი:",
            email: "იმეილი:",
            country: "Country:",
            namePlace: "სახელი",
            surnamePlace: "გვარი",
            emailPlace: "qwerty@mail.ru",
            countryPlace: "შეარჩიე ქვეყანა",
            loginBtn: "დაწყება"
        },
        main: {
            welcomeTitle: "კეთილი იყოს თქვენი მობრძანება საკუთარი პიროვნების შეცნობის კითხვარში!",
            welcomeText: "ეს ონლაინ კითხვარი შედგენილია საკუთარი თავის და სხვების უკეთ შესაცნობად, იმის გასაგებად, ვინ ვართ, როგორ ვიქცევით, როგორ აღგვიქვამენ სხვები და როგორ გამოვხატავთ ერთმანეთისადმი ემპათიას. მოკლედ რომ ვთქვათ, ჩვენ ახალი პერსპექტივიდან დავინახავთ საკუთარ და სხვების ძლიერ და სუს მხარეებს.",
            anketaInfo: "კითხვარი მოიცავს 15 კითხვას და შესავსებად დაახლოებით 7 წუთი დაგჭირდებათ. უპასუხეთ სპონტანურად და გულახდილად.",
            inAnketBtn: "კითხვარს იხილავთ აქ",
            info1: "კითხვარი მოგაწოდათ ორგანიზაციამ ",
            infoLink: "BPN Georgia",
            infoLinkPath: "https://bpngeorgia.ge/",
            info2: ": BPN Georgia - ძლიერი მეწარმეობისთვის საქართველოში!"
        },
        qInfo: {
            first: "შემდგომ ორ გვერდზე მოცემულია 15 თემატურად დალაგებული წინადადებათა ჯგუფი. თითოეულში 4 წინადადება ერთიანდება.",
            second: "შეარჩიეთ ოთხი წინადადებიდან ერთ - ერთი, რომელიც:",
            threeOne: "„ყველაზე მეტად“ შეგესაბამებათ = 4 ქულა",
            threeTwo: "„შედარებით მეტად“ შეგესაბამებათ = 3 ქულა",
            threeThree: "„უფრო არ“ შეგესაბამებათ = 2 ქულა",
            threeFour: "„ყველაზე ნაკლებ“ შეგესაბამებათ = 1 ქულა",
            fourty: "4 წინადადებიდან რომელიც ყველაზე მეტად შეგესაბამებათ, შეაფასეთ 4 ქულით. რომელიც ყველაზე ნაკლებ შეგესაბამებათ - 1 ქულით. თითოეული ქულა შეგიძლიათ მიუთითოთ მხოლოდ ერთხელ.",
            fifth: "არ აქვს მნიშვნელობა, კითხვარს პროფესიული პერსპექტივიდან გამომდინარე ავსებთ თუ პირადი პერსპექტივიდან. მთავარია ჩამოყალიბდეთ ერთ რომელიმე პერსპექტივაზე.",
            inAnketBtn: "კითხვარი",
            inBackBtn: "დასაწყისზე დაბრუნება"
        },
        question: {
            qInfo1: "კითხვა",
            qInfo2: "/15",
            inNextBtn: "შემდეგი",
            inStartBtn: "დასაწყისზე დაბრუნება",
            inBackBtn: "უკან დაბრუნება",
            badMessageTxT: "There are unmarked questions on the page",
            "4Punkt": "ყველაზე მეტად",
            "3Punkt": "შედარებით მეტად",
            "2Punkt": "უფრო არ",
            "1Punkt": "ყველაზე ნაკლებ",
            1: [{
                id: 1,
                title: "მე შეუპოვრად ვმუშაობ",
            },
                {
                    id: 2,
                    title: "მე აღფრთოვანებით ვმუშაობ",
                },
                {
                    id: 3,
                    title: "მე სწრაფად ვაღწევ შედეგებს",
                },
                {
                    id: 4,
                    title: "მე სიზუსტით ვმუშაობ",
                }
            ],
            2: [{
                id: 1,
                title: "მე სიამოვნებით ვყვები ხოლმე ჩემს ამბებს",
            },
                {
                    id: 2,
                    title: "მე ყურადღებით ვუსმენ და სწორ კითხვებს ვსვამ",
                },
                {
                    id: 3,
                    title: "მე სიამოვნებით ვუსმენ და ვიძლევი სასარგებლო რჩევებს",
                },
                {
                    id: 4,
                    title: "მე ვსაუბრობ ნათლად და ფოკუსირებულად",
                }
            ],
            3: [{
                id: 1,
                title: "მე სიამოვნებით ვიღებ სიახლეებს",
            },
                {
                    id: 2,
                    title: "მე ადვილად ვუმკლავდები გამოწვევებს",
                },
                {
                    id: 3,
                    title: "მე სიზუსტით ვმუშაობ და უზრუნველვყოფ დეტალების შესაბამისობას",
                },
                {
                    id: 4,
                    title: "მსიამოვნებს ისეთ გუნდში მუშაობა, სადაც ყველა კარგად გრძნობს თავს",
                }
            ],
            4: [{
                id: 1,
                title: "მე ვუჩვენებ თანაგრძნობას",
            },
                {
                    id: 2,
                    title: "მე ძლიერი ნებისყოფა მაქვს",
                },
                {
                    id: 3,
                    title: "მე ტაქტიანი ვარ",
                },
                {
                    id: 4,
                    title: "მე ბევრი იდეები მაქვს",
                }
            ],
            5: [{
                id: 1,
                title: "მე ვეძებ კონკურენტულ სიტუაციებს",
            },
                {
                    id: 2,
                    title: "ვცდილობ გუნდი დავაბალანსო",
                },
                {
                    id: 3,
                    title: "მსიამოვნებს მხიარულ, გულღია ატმოსფეროში ყოფნა",
                },
                {
                    id: 4,
                    title: "ვცდილობ დავრწმუნდე, რომ გუნდში ყველა იცავს წესებს",
                }
            ],
            6: [{
                id: 1,
                title: "სანამ გადაწყვეტილებას მივიღებ, ვეკითხები სხვებს",
            },
                {
                    id: 2,
                    title: "გადაწყვეტილებას სპონტანურად და ინტუიციურად ვიღებ",
                },
                {
                    id: 3,
                    title: "არასასიამოვნო გადაწყვეტილებებსაც კი სწრაფად ვიღებ",
                },
                {
                    id: 4,
                    title: "სანამ გადაწყვეტილებას მივიღებ, ვაგროვებ ფაქტებს და ვაანალიზებ",
                }
            ],
            7: [{
                id: 1,
                title: "ხშირად ვარ საუბრის ინიციატორი და უცნობებს სახალისო ისტორიებსაც ვუყვები",
            },
                {
                    id: 2,
                    title: "ვსაუბრობ სწრაფად და ლოგიკურად",
                },
                {
                    id: 3,
                    title: "საუბრისას სხვების მდგომარეობას ვითვალისწინებ",
                },
                {
                    id: 4,
                    title: "მე ვუძღვები საუბარს და სწრაფად მივდივარ მთავარ სათქმელამდე",
                }
            ],
            8: [{
                id: 1,
                title: "მე შემიძლია საკუთარი თავის და გრძნობების კონტროლი",
            },
                {
                    id: 2,
                    title: "ადამიანების უმრავლესობა სასიამოვნოდ მიმიჩნევს",
                },
                {
                    id: 3,
                    title: "მე ვამჩნევ, რას განიცდიან სხვები, რომც არ აღიარონ",
                },
                {
                    id: 4,
                    title: "მე ყოველთვის ჩემს აზრზე ვრჩები, სხვები რომც სხვაგვარად ფიქრობდნენ",
                }
            ],
            9: [{
                id: 1,
                title: "კონფლიქტისას მომყავს საქმიანი არგუმენტები",
            },
                {
                    id: 2,
                    title: "ვცდილობ კონფლიქტების მოგვარებას ან თავიდან არიდებას",
                },
                {
                    id: 3,
                    title: "კონფლიქტებს პირდაპირ და უშიშრად ვხვდები",
                },
                {
                    id: 4,
                    title: "კონფლიქტი მარტივად ჩნდება, ამიტომ მე მათ მარტივადვე ვივიწყებ",
                }
            ],
            10: [{
                id: 1,
                title: "ადამიანები მიმიჩნევენ სანდო პიროვნებად",
            },
                {
                    id: 2,
                    title: "ადამიანები მიიჩნევენ, რომ ადვილია ჩემი აღფრთოვანება",
                },
                {
                    id: 3,
                    title: "ადამიანები მიმიჩნევენ კეთილსინდისიერ პიროვნებად",
                },
                {
                    id: 4,
                    title: "ადამიანები მიმიჩნევენ ჩამოყალიბებულ პიროვნებად",
                }
            ],
            11: [{
                id: 1,
                title: "მსიამოვნებს ბევრი ადამიანის წინაშე სიტყვით გამოსვლა",
            },
                {
                    id: 2,
                    title: "მე მირჩევნია 1 ან 2 ადამიანთან საუბარი მეტი კონცენტრირების მიზნით",
                },
                {
                    id: 3,
                    title: "მე ვსაუბრობ, რათა ფაქტებით და ცოდნით დავარწმუნო სხვები",
                },
                {
                    id: 4,
                    title: "მე ვსაუბრობ, რათა ჩემს ნათქვამს ჰქონდეს ძალა და ადამიანებს ქმედებისკენ ვუბიძგო",
                }
            ],
            12: [{
                id: 1,
                title: "შედეგები ჩემთვის მნიშვნელოვანია",
            },
                {
                    id: 2,
                    title: "ჰარმონია ჩემთვის მნიშვნელოვანია",
                },
                {
                    id: 3,
                    title: "სიახლეები და მრავალფეროვნება ჩემთვის მნიშვნელოვანია",
                },
                {
                    id: 4,
                    title: "სიზუსტე ჩემთვის მნიშვნელოვანია",
                }
            ],
            13: [{
                id: 1,
                title: "მე ადვილად შემიძლია ადამიანების დაყოლიება",
            },
                {
                    id: 2,
                    title: "უმოქმედობა მიჭირს",
                },
                {
                    id: 3,
                    title: "მესმის სხვისი საფიქრალი და პრობლემები",
                },
                {
                    id: 4,
                    title: "უფრო თავშეკავებული და ჩაკეტილი ვარ",
                }
            ],
            14: [{
                id: 1,
                title: "მე მყარი პიროვნება ვარ",
            },
                {
                    id: 2,
                    title: "მე ფრთხილი პიროვნება ვარ",
                },
                {
                    id: 3,
                    title: "მე შთამაგონებელი პიროვნება ვარ",
                },
                {
                    id: 4,
                    title: "მე თანმიმდევრული ვარ, სანამ რაღაც არ მოგვარდება",
                }
            ],
            15: [{
                id: 1,
                title: "მსურს კონტროლი შევინარჩუნო",
            },
                {
                    id: 2,
                    title: "მსურს გავერთო",
                },
                {
                    id: 3,
                    title: "მსურს ნაკლებ დავიხარჯო",
                },
                {
                    id: 4,
                    title: "მსურს ყველაფერი სწორად გაკეთდეს",
                }
            ]
        },
        result: {
            mailMsg: "Message success sending!",
            goodMessageAnswer: "ინფორმაცია გამოგეგზავნათ ელექტრონულ მისამართზე",
            goodMessageAnswer2: "შესაძლებელია კითხვარის მეგობრებთან გაზიარება, თუ დააჭერთ ღილაკს აქ:",
            title: "პიროვნების პროფილის შეფასება",
            eagleBall: "ქულების ჯამი. პიროვნების ტიპი «არწივი»",
            monkeyBall: "ქულების ჯამი. პიროვნების ტიპი «მაიმუნი»",
            pandaBall: "ქულების ჯამი. პიროვნების ტიპი «პანდა»",
            beeBall: "ქულების ჯამი. პიროვნების ტიპი «ფუტკარი»",
            type: "ტიპი",
            balls: "ქულა",
            percents: "პროცენტი",
            resultTxt1: "თუ შედეგები აღემატება 36 - ს, ანუ სცდება სქემაში ჩახატულ კვადრატს, ითვლება, რომ ეს ტენდენცია თქვენში უფრო შეინიშნება. თუ არ აღემატება 36 - ს, უფრო არ განიხილება თქვენს მიდრეკილებად. თქვენ შენიშნავთ, რომ ყველა ტიპის ქცევის ტენდენციები გახასიათებთ. ერთმნიშვნელოვნად «არწივი» თუ «ფუტკარი» არ არსებობს.",
            resultTxt12: "რაც უფრო მაღლა იწევს მონაცემები პიროვნების პროფილში, მით უფრო მეტ მახასიათებლებს იპოვით კონკრეტული ქცევის ტიპაჟის დახასიათებაში. ხოლო თუ თქვენი მონაცემები პიროვნების ოთხივე ტიპთან მიმართებაში მეტნაკლებად დაბალანსებულია,",
            resultTxtLink: "დახასიათებაში",
            resultTxt2: "მახასიათებლები ნაწილობრივ შეგეხებათ ან სხვადასხვა სიტუაციების მიხედვით სხვადასხვა ქცევის სტილს გამოამჟღავნებთ.",
            resultTxtBold: "ყველა ადამიანი არის განსაკუთრებული, უნიკალური! პიროვნების პროფილი ამ უნიკალურობას წარმოაჩენს და არავითარ კავშირშია კარგთან ან ცუდთან. ეს არის თქვენი პიროვნების ანარეკლი, თუ როგორ აღგიქვამენ სხვები თქვენ.",
            resultTxt3: "თუ გსურთ შეიტყოთ მეტი სხვადასხვა ტიპის პიროვნების ქცევის ტენდენციების შესახებ, დარეგისტრირდით ",
            resultTxt4: "კადრების მართვის სემინარზე",
            resultTxt5: " BPN Georgia - ში.",
            resultBpnLink: "https://bpngeorgia.ge/business-academy/seminars-workshops",
            sendMailBtn: "შეფასების გაგზავნა pdf - ით",
            backOnBtnLink: "https://bpngeorgia.ge/",
            shareWithFriendsBtn: "კითხვარის გაზიარება მეგობრებთან",
            restartBtn: "კითხვარის ხელახლა შევსება",
            backOnMainBtn: "BPN Georgia - ს ვებ გვერდზე დაბრუნება",
            emailHead: "Share this questionnaire",
            emailMessage: "Enter mail:",
            emailSendBtn: "Send",
            emailSuccessTxt: "Was sent!",
            emailLinkTxt: "Link Fragebogen Persönlichkeitsprofil",
            emailPlaceholder: "A message will be sent to this mail.",
            emailMessageToFriend: "პიროვნების პროფილი (BPN).\nგამარჯობა! გირჩევთ შეავსოთ პიროვნების პროფილის ეს კითხვარი!\n იხილეთ აქ"
        },
        fourTendentions: {
            title: "ქცევის 4 ტიპის დახასიათება",
            eagleTitle: "არწივი",
            eagleGrayTxt: "არწივი მოელის აღიარებას მისი ქმედებებისა და მიღწევებისთვის. მისთვის გამოწვევები და გამარჯვებები მამოტივირებელია.",
            eagleTxt: "არწივს აქვს საკუთარი თავის ნდობა და ორიენტირებულია შედეგებზე, რომლის მიღწევაც სწრაფად სურს. მას აქვს მოქმედებისკენ მუდმივი ლტოლვა მანამ, სანამ სასურველ შედეგს არ მიიღებს. გამოწვევები უფრო მეტი ქმედითუნარიანობისკენ უბიძგებს. სიმამაცით ეჭიდება პრობლემებს და უდიდეს სიამოვნებას განიცდის, როცა კონკურენციიდან და წინააღმდეგობებიდან გამარჯვებული გამოდის. ის არსებულ მდგომარეობას მუდამ კითხვის ნიშნის ქვეშ აყენებს და შეუძლია არაორდინალურად იაზროვნოს. არწივი სწრაფად გადადის მთავარ თემაზე. გააქვს საკუთარი აზრი პირდაპირ, ღიად, ხშირად უხეშად. მოსწონს, როცა თემაზე კონცენტრირებულად საუბრობენ და სათქმელს დროულად ამბობენ. არწივს მოსწონს მრავალფეროვანი და ახალ-ახალი საქმიანობები. საკუთარი თავის უფროსი თავად უნდა იყოს. მან იცის, რა სურს. რა თქმა უნდა კონტროლს საკუთარ თავზე იღებს, ადგენს წესებს თავის გარემოცვაში და კარნახობს სხვებს, რა უნდა მოიმოქმედონ. ის საკუთარ თავსაც ბევრს სთხოვს და სხვებსაც და ხვდება, რომ ზოგჯერ ზედმეტი მოსდის, რადგან გაცნობიერებული აქვს, რომ ყველა მასავით ენერგიული ვერაა.",
            eagleSlogan1: "მისი დევიზია:",
            eagleSlogan2: "«შესრულებულია! მიზანი მიღწეულია! ყველაფერი კონტროლს ექვემდებარება!»",
            monkeyTitle: "მაიმუნი",
            monkeyGrayTxt: "სურს მისი საქციელი და დამოკიდებულებები გარშემომყოფებს მოსწონდეთ. მამოტივირებელი ძალა მისთვის გართობაა და მოსწონს კონტაქტების დამყარება.",
            monkeyTxt: "მაიმუნს არაფერი მოსწონს იმაზე მეტად, ვიდრე სხვისი მოტივირება, დარწმუნება დასხვაზე ზემოქმედება. უყვარს, როცა უსმენენ და აზრს ზედმიწევნით გამოხატავს.მისი საუბრის მანერა ემოციურია, გამომხატველობითი და ღია, რომლის დროსაც მოელის მსმენელისგან მისი აზრების მიღებას და აღიარებას. სიამოვნებით მუშაობსსხვების გარემოცვაში. შეუძლია საუბარშივე შეცვალოს საკუთარი იდეები. საკუთარი ისტორიებით შეუძლია სხვების გულის მოგება და აღფრთოვანება. ის საუბრისასთემებს ხშირად ცვლის და ერთსა და იმავე თემაზე დიდხანს არ ჩერდება. მისი ქმედებები და გადაწყვეტილებები ხშირად სპონტანურია და ინტუიციით ნაკარნახევი.დეტალებში ჩაღრმავება, სიზუსტე და კონტროლი მის კრეატიულობას ბოლოს უღებს. მისი ენერგია ხშირად იფლანგება მრავალ და ამაო აქტივობებში, რადგან არ აქვს ნათლად ჩამოყალიბებული მიზანი.",
            monkeySlogan1: "მისი დევიზია:",
            monkeySlogan2: "«მოდი გავერთოთ! ამან სიამოვნება მომანიჭა!»",
            pandaTitle: "პანდა",
            pandaGrayTxt: "პანდა უპირატესობას ანიჭებს სტაბილურ, პროგნოზირებად და მოწესრიგებულ გარემოს და სიამოვნებს განმუხტული და მეგობრული ატმოსფერო.",
            pandaTxt: "ჰარმონია და გუნდურობა მისთვის მთავარი პრიორიტეტია. მას ყოველთვის სხვისი მხარში დგომა და კარგი ურთიერთობების ჩამოყალიბება სურს. ცხადი და სამართლიანი შეთანხმებები და პროგნოზირებადი პროცესები აუცილებელია მისთვის, რომ თავი უსაფრთხოდ იგრძნოს. ტკბება ადამიანთან ყოფნის სიმყუდროვით და მოსწონს საქმის მშვიდ გარემოში შესრულება. აკონტროლებს ტემპს, რომ არ ჩამორჩეს მოცემულობებს. მისგან დავალებების შესრულების იმედი მუდამ შეგიძლიათ გქონდეთ. ის კარგი სტრატეგია და ამოცანებს ნაბიჯ-ნაბიჯ უმკლავდება. პანდას არ უყვარს სცენაზე დგომა, ამიტომ ყოველთვის თავს არიდებს საკუთარი თავის პოზიტიურად წარმოჩენას. ის სიამოვნებით მუშაობს სხვებთან ერთად მანამ, სანამ\n" +
                "სასიამოვნო სამუშაო ატმოსფერო სუფევს. როცა მისი დახმარება სჭირდებათ, ერთი შეხედვით მოდუნებული პანდა არ იშურებს საკუთარ ძალას და ენერგიას.",
            pandaSlogan1: "მისი დევიზია:",
            pandaSlogan2: "«ყველა კარგად უნდა გრძნობდეს თავს! დროს ერთად სასიამოვნოდ ვატარებთ!»",
            beeTitle: "ფუტკარი",
            beeGrayTxt: "სურს საკუთარი უბადლოდ შესრულებული დავალებისთვის აღიარება. მისთვის მოტივაციის წყაროს წარმოადგენენ ციფრები, ფაქტები და სიზუსტე.",
            beeTxt: "ფუტკარი თავს მოტივირებულად გრძნობს, როცა საქმე სტანდარტებს და ხარისხს ეხება. მას შეუძლია ანალიზი, დადებითი და უარყოფითი მხარეების აწონ დაწონვა და ამ ყოველივეს დიპლომატიურ ენაზე გადაცემა სხვებისთვის. ის ჩაკეტილია. მას სურს «სწორი» საქმე გააკეთოს «სწორად», თავი აარიდოს კრიტიკას, გულისწყრომას და ყურადღება მიაქციოს სიზუსტეს. ის გეგმავს გულდასმით და ითვალისწინებს ყოველ დეტალს, თუმცა ხშირად იკარგება საკუთარ პერფექციონიზმში, ნაცვლად იმისა, რომ სხვა მნიშვნელოვან საკითხებსაც მიაქციოს ყურადღება. თავს კარგად გრძნობს, როცა მოლოდინებს ნათლად უყალიბებენ, იდეალურ შემთხვევაში წერილობით, სხვადასხვა პროცესების სახით. ემოციურად დამუხტულ სიტუაციებში თავს მაინცდამაინც კომფორტულად ვერ გრძნობს და ამჯობინებს საქმიან და ლოგიკურ არგუმენტებს. პირად ცხოვრებას მკაცრად მიჯნავს სამსახურეობრივი ცხოვრებისგან. რაკი ხშირად ჩაკეტილი და ცივია და ემოციებს არ აჩვენებს, უგრძნობის და გულცივის შთაბეჭდილებას ტოვებს, რაც ხშირად სიმართლეს არ შეესაბამება. მიუხედავად იმისა, რომ გარეგნულად არ იმჩნევს, საკმაოდ მგრძნობიარეა და ადვილად სწყინს. ფუტკარი სიამოვნებით მუშაობს სხვა მასავით ორგანიზებულ და მაღალი სტანდარტების მქონე ადამიანებთან ერთად. ის თავს ზედმეტი ზეწოლის ქვეშ არ აყენებს, არამედ სჭირდება გარედან შემოძახილი. თუმცა თუ მადა გაეხსნა რაიმე პრობლემატიკის მიმართ, შეუძლია დისციპლინირებულად მიუდგეს საკითხს მანამ, სანამ საბოლოოდ არ გადაჭრის.",
            beeSlogan1: "მისი დევიზია:",
            beeSlogan2: "«უნდა გაკეთდეს სწორად. უნდა ემთხვევოდეს. უბადლოდ შესრულებული სამუშაო!»",
        }
    },
    "german": {
        header: {
            loginBtn: "Login",
            changeLangTxt: "Sprache ändern",
            logoutBtn: "Logout"
        },
        admin: {
            delQuestion: "Möchten Sie wirklich alle Resultaten löschen?",
            sign: "Enter",
            passMsg: "Enter password:"
        },
        auth: {
            name: "Your name:",
            surname: "Your surname:",
            email: "Email:",
            country: "Country:",
            namePlace: "Name",
            surnamePlace: "Surname",
            emailPlace: "qwerty@mail.ru",
            countryPlace: "Select country",
            loginBtn: "Start"
        },
        main: {
            welcomeTitle: "Herzlich Willkommen zum Persönlichkeitsprofil-Fragebogen!",
            welcomeText: "Dieser Online-Fragebogen wurde entwickelt, damit Sie sich und andere besser\n" +
                "kennenlernen, verstehen, wer wir sind, wie wir handeln, fühlen und auf andere Menschen\n" +
                "wirken. Kurz gesagt: Sie erhalten einen völlig neuen Blick auf Ihre eigenen Stärken und\n" +
                "Schwächen.",
            anketaInfo: "Der Fragebogen umfasst 15 Fragen und das Ausfüllen dauert ungefähr 7 Minuten. Antworten\n" +
                "Sie ehrlich und spontan.",
            inAnketBtn: "Hier kommen Sie zum Fragebogen",
            info1: "Dieser Fragebogen wird Ihnen zur Verfügung gestellt von ",
            infoLink: "BPN Swiss",
            infoLinkPath: "https://bpn.ch/",
            info2: ": Für ein starkes Unternehmertun!"
        },
        qInfo: {
            first: "Im folgenden werden Ihnen 15 thematisch geordnete Satzgruppen mit je vier Sätzen\n" +
                "präsentiert.",
            second: "Entscheiden Sie sich in jeder Satzgruppe für den Satz, der Ihnen:",
            threeOne: "„am ehesten“ entspricht = 4 Punkte",
            threeTwo: "„am zweitehesten“ entspricht = 3 Punkte",
            threeThree: "„eher nicht“ entspricht = 2 Punkte",
            threeFour: "„am wenigsten“ entspricht = 1 Punkt",
            fourty: "Dies bedeutet, dass in jeder Vierergruppe die Zahlen 1, 2, 3, und 4 genau einmal\n" +
                "vorkommen müssen.",
            fifth: "Denken Sie beim Ausfüllen an ein bestimmtes Umfeld. Es spielt keine Rolle, ob Sie den\n" +
                "Fragebogen für eine berufliche oder private Situation ausfüllen. Entscheiden Sie sich aber für\n" +
                "ein bestimmtes Umfeld!",
            inAnketBtn: "Zum Fragebogen",
            inBackBtn: "Zurück zum Start"
        },
        question: {
            qInfo1: "Frage",
            qInfo2: "von 15",
            inNextBtn: "Weiter",
            inStartBtn: "Zurück zum Start",
            inBackBtn: "Schritt zurück",
            badMessageTxT: "There are unmarked questions on the page",
            "4Punkt": "am ehesten",
            "3Punkt": "am zweit-ehesten",
            "2Punkt": "eher nicht",
            "1Punkt": "am wenigsten",
            1: [{
                id: 1,
                title: "Ich arbeite beständig",
            },
                {
                    id: 2,
                    title: "Ich arbeite mit Begeisterung",
                },
                {
                    id: 3,
                    title: "Ich erreiche schnell Resultate",
                },
                {
                    id: 4,
                    title: "Ich arbeite exakt",
                }
            ],
            2: [{
                id: 1,
                title: "Ich erzähle gerne was mir passiert ist",
            },
                {
                    id: 2,
                    title: "Ich höre genau zu und stelle die richtigen Fragen",
                },
                {
                    id: 3,
                    title: "Ich höre gerne zu und gebe Ratschläge, die helfen",
                },
                {
                    id: 4,
                    title: "Ich spreche klar und fokussiert",
                }
            ],
            3: [{
                id: 1,
                title: "Ich nehme gerne Neues in Angriff",
            },
                {
                    id: 2,
                    title: "Ich bin schnell fertig mit herausfordernden Aufgaben",
                },
                {
                    id: 3,
                    title: "Ich arbeite genau und stelle sicher, dass auch Details stimmen",
                },
                {
                    id: 4,
                    title: "Ich arbeite gerne in einem Team, wo es allen gut geht",
                }
            ],
            4: [{
                id: 1,
                title: "Ich bin mitfühlend",
            },
                {
                    id: 2,
                    title: "Ich bin willensstark",
                },
                {
                    id: 3,
                    title: "Ich bin taktvoll",
                },
                {
                    id: 4,
                    title: "Ich bin ideenreich",
                }
            ],
            5: [{
                id: 1,
                title: "Mit anderen bin ich oft konkurrierend",
            },
                {
                    id: 2,
                    title: "Ich versuche auszugleichen in einer Gruppe",
                },
                {
                    id: 3,
                    title: "Ich habe gerne gesellige und fröhliche Runden",
                },
                {
                    id: 4,
                    title: "In einer Gruppe versuche ich sicherzustellen, dass die Regeln eingehalten werden"
                }
            ],
            6: [{
                id: 1,
                title: "Ich frage auch andere bevor ich mich entscheide",
            },
                {
                    id: 2,
                    title: "Ich entscheide spontan und intuitiv",
                },
                {
                    id: 3,
                    title: "Ich treffe auch unangenehme Entscheide schnell",
                },
                {
                    id: 4,
                    title: "Ich sammle und analysiere Fakten bevor ich entscheide",
                }
            ],
            7: [{
                id: 1,
                title: "Ich initiiere gerne Gespräche und erzähle auch Unbekannten\n" +
                    "\n" +
                    "lustige Geschichten",
            },
                {
                    id: 2,
                    title: "Ich spreche sachlich und logisch",
                },
                {
                    id: 3,
                    title: "Im Gespräch versuche ich auf Andere einzugehen",
                },
                {
                    id: 4,
                    title: "Ich führe Gespräche und komme schnell auf den Punkt",
                }
            ],
            8: [{
                id: 1,
                title: "Ich kann mich und meine Gefühle gut beherrschen",
            },
                {
                    id: 2,
                    title: "Grundsätzlich finden mich die meisten Menschen nett",
                },
                {
                    id: 3,
                    title: "Ich merke wie es anderen geht, auch wenn sie nichts sagen",
                },
                {
                    id: 4,
                    title: "Ich bleibe meiner Linie treu, auch wenn es alle anders sehen",
                }
            ],
            9: [{
                id: 1,
                title: "In Konflikten argumentiere ich sachlich",
            },
                {
                    id: 2,
                    title: "Ich versuche Konflikte zu vermeiden oder zu schlichten",
                },
                {
                    id: 3,
                    title: "Ich gehe Konflikte direkt und ohne Angst an",
                },
                {
                    id: 4,
                    title: "Konflikte gibt es halt einfach, deshalb vergesse ich sie auch\n" +
                        "\n" +
                        "schnell wieder",
                }
            ],
            10: [{
                id: 1,
                title: "Menschen erleben mich als verlässlich",
            },
                {
                    id: 2,
                    title: "Menschen erleben mich als begeistert",
                },
                {
                    id: 3,
                    title: "Menschen erleben mich als gewissenhaft",
                },
                {
                    id: 4,
                    title: "Menschen erleben mich als entschlossen",
                }
            ],
            11: [{
                id: 1,
                title: "Ich geniesse es vor vielen Menschen zu sprechen",
            },
                {
                    id: 2,
                    title: "Ich spreche lieber nur mit 1 oder 2 Personen, um auf sie\n" +
                        "\n" +
                        "eingehen zu können",
                },
                {
                    id: 3,
                    title: "Ich spreche, um mit Fakten und Wissen zu überzeugen",
                },
                {
                    id: 4,
                    title: "Ich spreche, um etwas zu bewirken und Menschen dazu zu bringen etwas zu tun",
                }
            ],
            12: [{
                id: 1,
                title: "Resultate sind mir wichtig",
            },
                {
                    id: 2,
                    title: "Harmonie ist mir wichtig",
                },
                {
                    id: 3,
                    title: "Neues und Abwechslung sind mir wichtig",
                },
                {
                    id: 4,
                    title: "Genauigkeit ist mir wichtig",
                }
            ],
            13: [{
                id: 1,
                title: "Ich kann Menschen einfach für etwas gewinnen",
            },
                {
                    id: 2,
                    title: "Es fällt mir schwer untätig zu sein",
                },
                {
                    id: 3,
                    title: "Ich habe Verständnis für Anliegen und Probleme der Anderen",
                },
                {
                    id: 4,
                    title: "Ich bin eher zurückhaltend und reserviert",
                }
            ],
            14: [{
                id: 1,
                title: "Ich bin eine beständige Person",
            },
                {
                    id: 2,
                    title: "Ich bin vorsichtig",
                },
                {
                    id: 3,
                    title: "Ich bin inspirierend",
                },
                {
                    id: 4,
                    title: "Ich bin hartnäckig, bis etwas erledigt ist",
                }
            ],
            15: [{
                id: 1,
                title: "Ich will die Kontrolle behalten",
            },
                {
                    id: 2,
                    title: "Ich will Spass haben",
                },
                {
                    id: 3,
                    title: "Ich will wenig Aufwand haben",
                },
                {
                    id: 4,
                    title: "Ich will, dass es richtig ist",
                }
            ]
        },
        result: {
            mailMsg: "Message success sending!",
            goodMessageAnswer: "Die Nachricht wurde auf Ihre Email Adresse zugestellt.\n",
            goodMessageAnswer2: "                    Sie können auch diesen Fragenbogen mit Freunden teilen, wenn Sie den Link unten klicken!",
            title: "Auswertung Persönlichkeitsprofil",
            eagleBall: "Total Punkte Persönlichkeitstyp\n" +
                "«Adler»",
            monkeyBall: "Total Punkte Persönlichkeitstyp «Affe»",
            pandaBall: "Total Punkte Persönlichkeitstyp «Panda»",
            beeBall: "Total Punkte Persönlichkeitstyp «Biene»",
            type: "Typ",
            balls: "Punkte",
            percents: "Prozent",
            resultTxt1: "Diejenigen Merkmale, welche den Wert von 36 übersteigen, also ausserhalb des\n" +
                "eingezeichneten Quadrats liegen, werden eher als vorhanden wahrgenommen, diejenigen,\n" +
                "welche unter dem Wert von 36 liegen, eher als Manko wahrgenommen. Sie werden\n" +
                "feststellen, dass Sie Anteile von allen Verhaltenstendenzen besitzen. Es gibt also weder den\n" +
                "«Adler» noch die «Biene» in Reinkultur.",
            resultTxt12: "Je ausgeprägter die Extreme Ihres Persönlichkeitsprofils sind, desto mehr werden Sie sich in\n" +
                "den",
            resultTxtLink: "Beschreibungen zu den vier Verhaltenstendenzen",
            resultTxt2: "finden. Wenn Ihre Punktwerte zu den\n" +
                "vier Persönlichkeitstypen einigermassen ausgeglichen sind, werden Sie nur bei einem Teil\n" +
                "der Aussagen zustimmen, oder je nach Situation andere Verhaltensweisen aufzeigen.",
            resultTxtBold: "Jeder Mensch ist einzigartig! Ihr Persönlichkeitsprofil bringt diese Einzigartigkeit zum\n" +
                "Vorschein und hat nichts mit Gut oder Schlecht zu tun. Es gibt ein Spiegelbild Ihrer\n" +
                "Persönlichkeit wieder, wie andere Sie wahrnehmen.",
            resultTxt3: "Wenn Sie mehr zu den Verhaltenstendenzen der vier Persönlichkeitstypen wissen möchten,\n" +
                "dann melden Sie sich heute zum",
            resultTxt4: "BPN Mitarbeiterführungsseminar",
            resultBpnLink: "https://bpn.ch/",
            backOnBtnLink: "https://bpn.ch/",
            resultTxt5: " an.",
            sendMailBtn: "Auswertung als pdf\n" +
                "versenden",
            shareWithFriendsBtn: "Den Fragenbogen mit Freunden teilen",
            restartBtn: "Test nochmals machen",
            backOnMainBtn: "Zurück zur BPN Startseite",
            emailHead: "Share this questionnaire",
            emailSuccessTxt: "Was sent!",
            emailMessage: "Enter mail:",
            emailSendBtn: "Send",
            emailPlaceholder: "A message will be sent to this mail.",
            emailMessageToFriend: "Hallo! Diesen Persönlichkeitsprofil-Fragebogen musst Du unbedingt auch mal ausfüllen! Du findest Ihn hier:",
            emailLinkTxt: "Link Fragebogen Persönlichkeitsprofil"
        },
        fourTendentions: {
            title: "Beschreibungen zu den vier Verhaltenstendenzen",
            eagleTitle: "Der Adler",
            eagleGrayTxt: "Der Adler will Anerkennung für das, was er tut und erreicht. Er wird durch\n" +
                "Herausforderungen und Siege motiviert.",
            eagleTxt: "Der Adler hat ein grosses Selbstvertrauen und ist auf Resultate ausgerichtet, die er möglichst\n" +
                "schnell erreichen will. Er hat den Drang, tätig zu sein, bis er die angestrebten Ergebnisse\n" +
                "erreicht hat. Herausforderungen stacheln ihn zu noch mehr Leistung an. Mutig geht er\n" +
                "Probleme an und erfährt grosse Befriedigung, wenn er Widerstände oder auch Konkurrenz\n" +
                "überwinden kann. Dazu stellt er auch Bestehendes in Frage und kann querdenken. Der Adler\n" +
                "kommt schnell zum Kern einer Sache, ist durchsetzungsfähig, direkt, offen (und manchmal\n" +
                "auch grob). Er liebt es, wenn Andere fokussiert kommunizieren und schnell auf den Punkt\n" +
                "kommen. Der Adler mag abwechslungsreiche und auch neue Tätigkeiten und will sein\n" +
                "eigener Chef sein. Er weiss, was er will, übernimmt selbstverständlich die Kontrolle,\n" +
                "bestimmt gerne sein Umfeld und sagt Anderen, was sie zu tun haben. Er verlangt viel von\n" +
                "sich selbst, aber auch von Anderen und kann deshalb manchmal überfordern, weil ihm nicht\n" +
                "bewusst ist, dass nicht alle gleichviel Energie haben wie er.",
            eagleSlogan1: "Sein Motto:",
            eagleSlogan2: "«Erledigt! Ziel erreicht! Alles unter Kontrolle!»",
            monkeyTitle: "Der Affe",
            monkeyGrayTxt: "Will, dass so wie er sich verhält und benimmt, den Leuten gefällt. Wird mit Spass motiviert\n" +
                "und mag es, Kontakte zu knüpfen.",
            monkeyTxt: "Der Affe kann nicht anders als andere motivieren, überzeugen und beeinflussen zu wollen.\n" +
                "Dazu will er sich ausgiebig ausdrücken und gehört werden. Er kommuniziert spannend, offen\n" +
                "und drückt seine Gefühle aus. Dabei sucht er immer wieder Bestätigung und Annahme von\n" +
                "seinem Gegenüber. Am liebsten arbeitet er mit anderen zusammen. Er denkt, während er\n" +
                "spricht, so dass er seine eigenen Ideen noch während dem Sprechen wieder verwerfen\n" +
                "kann. Mit seinen Geschichten kann er problemlos andere begeistern und gewinnen. Er ist\n" +
                "sprunghaft und selten lange bei einem Thema. Seine Handlungen und Entscheide erfolgen\n" +
                "oft spontan und intuitiv. Details, Genauigkeit und Kontrolle lähmen seine Kreativität. Seine\n" +
                "Energie wird oft verschwendet, weil er sich in zu vielen Aktivitäten verzettelt oder kein klar\n" +
                "definiertes Ziel vor Augen hat.",
            monkeySlogan1: "Sein Motto:",
            monkeySlogan2: "«Lass uns Spass haben! Das hat Spass gemacht!»",
            pandaTitle: "Der Panda",
            pandaGrayTxt: "Der Panda bevorzugt ein stabiles, berechenbares und geordnetes Umfeld und liebt eine\n" +
                "entspannte und freundliche Atmosphäre.",
            pandaTxt: "Harmonie und ein guter Teamgeist haben für ihn absolute Priorität. Er will andere\n" +
                "unterstützen und für gute Beziehungen sorgen. Klare und faire Vereinbarungen sowie\n" +
                "vorhersehbare Abläufe vermitteln ihm die benötigte Sicherheit. Er kann das gemütliche\n" +
                "Zusammensein geniessen, und bevorzugt, seine Arbeit in Ruhe abarbeiten zu können, passt\n" +
                "aber seine Geschwindigkeit an, um Vorgaben einhalten zu können. Man kann sich auf die\n" +
                "Erledigung der Aufgaben verlassen, wenn man sie einem Panda gibt. Er zeichnet sich aus\n" +
                "als guter Planer und arbeitet seine Aufgaben Schritt um Schritt ab. Der Panda ist nicht gerne\n" +
                "im Rampenlicht und vermeidet es daher, sich selbst zu gut darzustellen. Er arbeitet gerne mit\n" +
                "Menschen zusammen, solange ein gutes Arbeitsklima herrscht. Wenn andere Menschen\n" +
                "seine Hilfe benötigen, schöpft der sonst eher träge Panda verborgene Kräfte.",
            pandaSlogan1: "Sein Motto:",
            pandaSlogan2: "«Allen geht’s gut! Wir haben eine gute Zeit zusammen!»",
            beeTitle: "Die Biene",
            beeGrayTxt: "Will, dass ihre hervorragende Arbeit anerkannt wird. Wird durch Zahlen, Fakten und\n" +
                "Genauigkeit motiviert.",
            beeTxt: "Die Biene wird durch Standards und Qualitätsansprüche angespornt. Dazu analysiert sie\n" +
                "gerne die notwendigen Dinge, wägt das Pro und Kontra ab und kommuniziert diplomatisch\n" +
                "und eher reserviert. Sie will unbedingt das Richtige «richtig» tun, Ärger und Kritik vermeiden\n" +
                "und achtet auf Präzision und Genauigkeit. Sie plant präzise und berücksichtigt alle\n" +
                "Einzelheiten, verliert sich dann aber manchmal in der Perfektion, statt auch andere wichtige\n" +
                "Dinge voranzutreiben. Sie fühlt sich wohl, wenn Erwartungen klar definiert und am besten\n" +
                "schriftlich in einer Prozessbeschreibung festgehalten werden. In gefühlsgeladenen\n" +
                "Situationen fühlt sie sich nicht besonders wohl und bevorzugt sachliche und logische\n" +
                "Argumentationen. Privatleben und Arbeit werden strikt getrennt. Weil sie oft kühl und\n" +
                "reserviert auftritt und kaum Gefühle zeigt, wird sie oft als unempfindlich und kaltherzig\n" +
                "beurteilt, obwohl oft das Gegenteil der Fall ist: auch wenn man es äusserlich nicht\n" +
                "wahrnehmen kann, sind sie oft sensibel und leicht verletzlich. Bienen arbeiten gerne mit\n" +
                "anderen Menschen zusammen, die organisiert sind und ebenfalls hohe Standards haben.\n" +
                "Sie haben nicht so viel Tatendrang, sondern benötigen meistens Anregung von extern,\n" +
                "können aber, wenn ihr Appetit für ein Problem mal geweckt ist, mit viel Disziplin an etwas\n" +
                "dranbleiben, bis es vollkommen gelöst ist.",
            beeSlogan1: "Ihr Motto:",
            beeSlogan2: "«Es muss richtig gemacht werden. Es muss stimmen. Exzellente Arbeit!»",
        }
    }
}

export default texts
